/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigDecimal: { input: number; output: number; }
  /** An instantaneous point on the time-line represented by a standard date time string */
  Instant: { input: string; output: string; }
  /** A date without a time-zone in the ISO-8601 calendar system using the format 1970-01-01 */
  LocalDate: { input: string; output: string; }
  Long: { input: number; output: number; }
  /** A date-time with an offset from UTC/Greenwich in the ISO-8601 calendar system using the format 1970-01-01T00:00:00Z */
  OffsetDateTime: { input: string; output: string; }
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  line1: Scalars['String']['output'];
  line2?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type AmountFilterInput = {
  /** Value is equals to the given amount, provided in minor currency units. */
  eq?: InputMaybe<Scalars['Long']['input']>;
  /** Value is greater than the given amount, provided in minor currency units. */
  gt?: InputMaybe<Scalars['Long']['input']>;
  /** Value is greater than or equal to the given amount, provided in minor currency units. */
  gte?: InputMaybe<Scalars['Long']['input']>;
  /** Value is less than the given amount, provided in minor currency units. */
  lt?: InputMaybe<Scalars['Long']['input']>;
  /** Value is less than or equal to the given amount, provided in minor currency units. */
  lte?: InputMaybe<Scalars['Long']['input']>;
};

export type AuBankAccountIdentifier = {
  __typename?: 'AuBankAccountIdentifier';
  accountNumber: Scalars['String']['output'];
  bsb: Scalars['String']['output'];
};

export type AuthenticationUnavailable = {
  __typename?: 'AuthenticationUnavailable';
  acsTransID: OptionString;
  authenticationValue: OptionString;
  directoryServerTransactionId: OptionString;
  eci: OptionString;
  info: OptionString;
  liabilityShifted: OptionBoolean;
  threeDSServerTransID: OptionString;
  transStatus: OptionString;
  transStatusReason: OptionString;
  version: OptionString;
  xid: OptionString;
};

/** A payment automatically taken from a credit balance. */
export type AutoPaymentFromCreditBalance = {
  __typename?: 'AutoPaymentFromCreditBalance';
  amount: Scalars['Long']['output'];
  timestamp: Scalars['Instant']['output'];
  user: Scalars['String']['output'];
};

export type BankAccountIdentifier = AuBankAccountIdentifier | HkBankAccountIdentifier | HkUsdBankAccountIdentifier | NzBankAccountIdentifier | SgBankAccountIdentifier;

export type BankAccountNode = {
  __typename?: 'BankAccountNode';
  /** System unique identifier for a bank account */
  accountId: Scalars['String']['output'];
  /** Name of the person or business that holds the account */
  accountName: Scalars['String']['output'];
  /** Name of financial institution where the account is held. */
  bankName?: Maybe<Scalars['String']['output']>;
  /** 2 letter ISO code indicating the country where the bank account is held. */
  country: Scalars['String']['output'];
  /** 3 letter ISO code indicating the currency of the bank account. */
  currency: Currency;
  /** Region specific identifier for the bank account. */
  identifier: BankAccountIdentifier;
  /** Is this the primary account for this merchant for the given currency. The primary account is the one payouts are made to. */
  isPrimaryForCurrency?: Maybe<Scalars['Boolean']['output']>;
};

export type Billing = {
  __typename?: 'Billing';
  address: Address;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type BusinessAddress = {
  __typename?: 'BusinessAddress';
  city?: Maybe<Scalars['String']['output']>;
  country: Country;
  postalCode: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  streetName: Scalars['String']['output'];
  streetNumber: Scalars['String']['output'];
  streetType?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
  unitNumber?: Maybe<Scalars['String']['output']>;
};

export type BusinessContactPerson = {
  __typename?: 'BusinessContactPerson';
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BusinessProfile = {
  __typename?: 'BusinessProfile';
  address: BusinessAddress;
  brandName: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  businessType: BusinessType;
  cardStatementName: Scalars['String']['output'];
  companyType?: Maybe<CompanyType>;
  contactEmailAddress: Scalars['String']['output'];
  contactPerson: BusinessContactPerson;
  industry: Industry;
  phoneNumber: Scalars['String']['output'];
  smsSenderName: Scalars['String']['output'];
  supportEmailAddress?: Maybe<Scalars['String']['output']>;
  supportSite: Scalars['String']['output'];
  taxCountry: Country;
  taxId?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  tradingCountry?: Maybe<Country>;
  verificationDocs: BusinessVerificationDoc;
  website: Scalars['String']['output'];
};

export enum BusinessType {
  Company = 'Company',
  Individual = 'Individual',
  Partnership = 'Partnership',
  SoleTrader = 'SoleTrader',
  Trust = 'Trust'
}

export type BusinessVerificationDoc = {
  __typename?: 'BusinessVerificationDoc';
  companyBackFileId?: Maybe<Scalars['String']['output']>;
  companyFrontFileId?: Maybe<Scalars['String']['output']>;
  companyTaxIdFileId?: Maybe<Scalars['String']['output']>;
  partnershipAgreementFileId?: Maybe<Scalars['String']['output']>;
  trustDeedAmendmentFileIds?: Maybe<Array<Scalars['String']['output']>>;
  trustDeedFileId?: Maybe<Scalars['String']['output']>;
};

export type CancelOnExpiry = {
  __typename?: 'CancelOnExpiry';
  timestamp: Scalars['Instant']['output'];
};

export enum CardBrand {
  AmericanExpress = 'AmericanExpress',
  DinersClub = 'DinersClub',
  Discover = 'Discover',
  Electron = 'Electron',
  Elo = 'Elo',
  Hiper = 'Hiper',
  Hipercard = 'Hipercard',
  Jcb = 'Jcb',
  Maestro = 'Maestro',
  MasterCard = 'MasterCard',
  Mir = 'Mir',
  Uatp = 'Uatp',
  UndefinedBrand = 'UndefinedBrand',
  UnionPay = 'UnionPay',
  Visa = 'Visa'
}

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  card3DSFlow?: Maybe<Scalars['String']['output']>;
  card3DSVerificationPassed?: Maybe<Scalars['Boolean']['output']>;
  cardBin?: Maybe<Scalars['String']['output']>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardCVCVerificationPassed?: Maybe<Scalars['Boolean']['output']>;
  cardCountry?: Maybe<Scalars['String']['output']>;
  cardExpiryDate?: Maybe<Scalars['String']['output']>;
  cardFunding?: Maybe<Scalars['String']['output']>;
  cardHolderName?: Maybe<Scalars['String']['output']>;
  cardIssuer?: Maybe<Scalars['String']['output']>;
  cardLast4?: Maybe<Scalars['String']['output']>;
  cardStatement?: Maybe<Scalars['String']['output']>;
  chargeReference?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<ErrorCode>;
  errorDetails?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  info3DSVerification?: Maybe<Scalars['String']['output']>;
  outcome3ds?: Maybe<Outcome3ds>;
  paymentMethodType: PaymentMethodType;
  walletType?: Maybe<Scalars['String']['output']>;
};

export enum CardSynonymTypeDto {
  RandomPan = 'RandomPan'
}

export enum CardUsage {
  /** The card may be charged more than once. */
  Multiple = 'Multiple',
  /** The card may be charged once. */
  Single = 'Single'
}

export type Charge = {
  __typename?: 'Charge';
  amount: Scalars['Long']['output'];
  autoPublishAt: Scalars['Instant']['output'];
  capturedAt?: Maybe<Scalars['Instant']['output']>;
  chargeFailure?: Maybe<Scalars['String']['output']>;
  chargeId: Scalars['String']['output'];
  createdAt: Scalars['Instant']['output'];
  currency: Scalars['String']['output'];
  customerStatementId?: Maybe<Scalars['String']['output']>;
  customerStatementIssueDate?: Maybe<Scalars['LocalDate']['output']>;
  customerStatementReferenceId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fxRateConversion: FxRateConversion;
  metadata: Scalars['String']['output'];
  metadataValidationOutcome?: Maybe<MetadataValidationOutcome>;
  netAmount: Scalars['Long']['output'];
  publicAt?: Maybe<Scalars['Instant']['output']>;
  publishedAt?: Maybe<Scalars['Instant']['output']>;
  status: ChargeStatus;
  taxAmount?: Maybe<Scalars['Long']['output']>;
  taxRate?: Maybe<Scalars['BigDecimal']['output']>;
  taxType?: Maybe<Scalars['String']['output']>;
  travelDetails: TravelDetails;
  updatedAt: Scalars['Instant']['output'];
};

export enum ChargeStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  NotCaptured = 'NotCaptured',
  Paid = 'Paid',
  PublishedToStatement = 'PublishedToStatement'
}

export enum ChargeStatusInput {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  NotCaptured = 'NotCaptured',
  Paid = 'Paid',
  PublishedToStatement = 'PublishedToStatement'
}

export enum CompanyType {
  Private = 'Private',
  Public = 'Public'
}

export enum Country {
  Australia = 'Australia',
  HongKong = 'HongKong',
  NewZealand = 'NewZealand',
  Singapore = 'Singapore',
  SouthAfrica = 'SouthAfrica',
  UnitedStates = 'UnitedStates'
}

/** Credit on this statement applied towards another statement. */
export type CreditAppliedToNewStatement = {
  __typename?: 'CreditAppliedToNewStatement';
  amount: Scalars['Long']['output'];
  paidStatementId: Scalars['String']['output'];
  timestamp: Scalars['Instant']['output'];
  user: Scalars['String']['output'];
};

export enum Currency {
  Aud = 'AUD',
  Hkd = 'HKD',
  Nzd = 'NZD',
  Sgd = 'SGD',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  currency: Currency;
  minorCurrencyUnits: Scalars['Long']['output'];
};

export type CustomerDetailsSubNode = {
  __typename?: 'CustomerDetailsSubNode';
  customerEmailAddress: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  referenceCustomerId?: Maybe<Scalars['String']['output']>;
};

/** Issued every day. */
export type Daily = {
  __typename?: 'Daily';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export enum DayOfWeek {
  Friday = 'Friday',
  Monday = 'Monday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

/** The field becomes required this many days after the entity was created. */
export type DaysRequiredWithin = {
  __typename?: 'DaysRequiredWithin';
  days: Scalars['Int']['output'];
};

export type DbiField = {
  __typename?: 'DbiField';
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export enum DerivedCardStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  OutOfLifetime = 'OutOfLifetime'
}

export type DigitalCardDetails = {
  __typename?: 'DigitalCardDetails';
  /** The first 6 digits of the card number. */
  bin: Scalars['String']['output'];
  cardBrand: CardBrand;
  cardCreator?: Maybe<Scalars['String']['output']>;
  cardHolderName: Scalars['String']['output'];
  digitalCreditCardIdSynonyms: Array<DigitalCreditCardIdSynonymDto>;
  /** Expiry in MM/YY form. */
  expiryDate: Scalars['String']['output'];
  issuerCountry: IsoCountry;
  last4: Scalars['String']['output'];
  /** Only populated for callers permitted to read full card numbers. */
  pan?: Maybe<Scalars['String']['output']>;
};

export type DigitalCardNode = {
  __typename?: 'DigitalCardNode';
  /** Amount still available to spend on the card, if a card limit applies. */
  availableBalance?: Maybe<IsoCurrencyAmount>;
  /** The first digits of the card number identifying the issuer. */
  bin: Scalars['String']['output'];
  cardBrand: CardBrand;
  cardHolderName: Scalars['String']['output'];
  /** Total spend limit for the card, if any. */
  cardLimit?: Maybe<IsoCurrencyAmount>;
  /** When the card was created. */
  createdAt: Scalars['Instant']['output'];
  /** A description of who or what created the card. */
  creator: Scalars['String']['output'];
  /** Originating currencies the card is restricted to. Empty means no restriction. */
  currencies: Array<Scalars['String']['output']>;
  /** System unique identifier for the digital card. */
  digitalCreditCardId: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Expiry as entered at checkout. */
  expiry: ExpiryDate;
  last4: Scalars['String']['output'];
  /** Per-transaction limit for the card, if any. */
  limit?: Maybe<IsoCurrencyAmount>;
  /** The loan this card is issued against. */
  loan?: Maybe<LoanNode>;
  /** Free-form metadata associated with the card. */
  metadata?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The card provider's identifier for the card. */
  providerIdentifier: Scalars['String']['output'];
  /** The card number with all but the last 4 digits masked. */
  redactedPan: Scalars['String']['output'];
  /** The card's effective status, taking its validity window into account. */
  status: DerivedCardStatus;
  /** Whether the card may be charged once or many times. */
  usage?: Maybe<CardUsage>;
  /** Start of the card's validity window. */
  validFrom: Scalars['Instant']['output'];
  /** End of the card's validity window. */
  validTo: Scalars['Instant']['output'];
};

export type DigitalCardSearchConnection = {
  __typename?: 'DigitalCardSearchConnection';
  edges: Array<DigitalCardSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type DigitalCardSearchEdge = {
  __typename?: 'DigitalCardSearchEdge';
  cursor: Scalars['String']['output'];
  node: DigitalCardNode;
};

export enum DigitalCardSearchOrderField {
  /** Order by when the card was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type DigitalCardSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: DigitalCardSearchOrderField;
};

export enum DigitalCardStatus {
  Active = 'Active',
  Cancelled = 'Cancelled'
}

export type DigitalCreditCardIdSynonymDto = {
  __typename?: 'DigitalCreditCardIdSynonymDto';
  cardSynonymType: CardSynonymTypeDto;
  synonym: Scalars['String']['output'];
};

export type DirectDebitFailure = {
  __typename?: 'DirectDebitFailure';
  code: DirectDebitFailureCode;
  detail: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum DirectDebitFailureCode {
  InsufficientFunds = 'InsufficientFunds',
  InvalidAccount = 'InvalidAccount',
  InvalidBsb = 'InvalidBsb',
  Other = 'Other'
}

export type DirectDebitPaymentMethod = {
  __typename?: 'DirectDebitPaymentMethod';
  accountLast4: Scalars['String']['output'];
  accountRoutingNumber?: Maybe<Scalars['String']['output']>;
  directDebitFailure?: Maybe<DirectDebitFailure>;
  directDebitStatus: DirectDebitStatus;
  paymentMethodType: PaymentMethodType;
  providerId: Scalars['String']['output'];
};

export enum DirectDebitStatus {
  Cleared = 'Cleared',
  Created = 'Created',
  Failed = 'Failed'
}

export type Dispute = {
  __typename?: 'Dispute';
  createdAt: Scalars['Instant']['output'];
  currency: Scalars['String']['output'];
  disputeAmount: Scalars['Long']['output'];
  disputeId: Scalars['String']['output'];
  metadata: Scalars['String']['output'];
  outcome: DisputeStatus;
  reason?: Maybe<Scalars['String']['output']>;
  referenceDisputeId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Instant']['output'];
};

export type DisputeNode = {
  __typename?: 'DisputeNode';
  /** When the dispute was created. */
  createdAt: Scalars['Instant']['output'];
  /** The currency of the transaction and dispute. */
  currency: Currency;
  /** The customer the disputed payment was taken from. */
  customer?: Maybe<MerchantCustomerNode>;
  /** Email address of the customer. */
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Full name of the customer. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Phone number of the customer. */
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** A free text description of the order. */
  description?: Maybe<Scalars['String']['output']>;
  /** The dispute fee charged to the merchant in minor currency units. */
  disputeFee: Scalars['Long']['output'];
  /** System unique identifier for the dispute. */
  disputeId: Scalars['String']['output'];
  /** The disputed amount in minor currency units. */
  disputedAmount: Scalars['Long']['output'];
  /** The order corresponding to the disputed payment. */
  order?: Maybe<OrderNode>;
  /** Metadata passed in when creating the order. */
  orderMetadata?: Maybe<Scalars['String']['output']>;
  /** The state of the dispute. */
  outcome?: Maybe<DisputeOutcome>;
  /** The reason provided by the customer for raising the dispute. */
  reason?: Maybe<Scalars['String']['output']>;
  /** A reference provided by the merchant to identify the order, such as an order number. */
  referenceOrderId: Scalars['String']['output'];
  /** The internal state of the dispute as reported by the underlying payment system. */
  state?: Maybe<Scalars['String']['output']>;
  /** The transaction being disputed. */
  transaction?: Maybe<TransactionNode>;
  /** The full transaction amount in minor currency units. */
  transactionAmount: Scalars['Long']['output'];
  /** When the dispute was last updated. */
  updatedAt: Scalars['Instant']['output'];
};

export enum DisputeOutcome {
  /** The dispute was resolved in the customer's favour. */
  Lost = 'Lost',
  /** The dispute has not yet been resolved. */
  Pending = 'Pending',
  /** The dispute was resolved in the merchant's favour. */
  Won = 'Won'
}

export type DisputeSearchConnection = {
  __typename?: 'DisputeSearchConnection';
  edges: Array<DisputeSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type DisputeSearchEdge = {
  __typename?: 'DisputeSearchEdge';
  cursor: Scalars['String']['output'];
  node: DisputeNode;
};

export enum DisputeSearchOrderField {
  /** Order by when the dispute was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type DisputeSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: DisputeSearchOrderField;
};

export enum DisputeStatus {
  CustomerLost = 'CustomerLost',
  CustomerWon = 'CustomerWon',
  Pending = 'Pending'
}

export type DisputeSubNode = {
  __typename?: 'DisputeSubNode';
  /** When the dispute was created. */
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The full dispute record, including its state, reason and outcome. */
  dispute?: Maybe<DisputeNode>;
  /** The disputed amount. */
  disputeAmount?: Maybe<CurrencyAmount>;
  /** The disputed fee in minor currency units. */
  disputeFee?: Maybe<Scalars['Long']['output']>;
  /** System unique identifier for the dispute. */
  disputeId: Scalars['String']['output'];
};

export type DtoExpiryAction = CancelOnExpiry | ExecuteOnExpiry | NoAction;

export enum DtoIssuerTransactionStatus {
  Cancelled = 'Cancelled',
  Disputed = 'Disputed',
  Failed = 'Failed',
  NotCaptured = 'NotCaptured',
  Paid = 'Paid',
  PartiallyRefunded = 'PartiallyRefunded',
  Refunded = 'Refunded'
}

export enum EntryType {
  Dispute = 'Dispute',
  DisputeFee = 'DisputeFee',
  DisputeFeeReversed = 'DisputeFeeReversed',
  DisputeReversed = 'DisputeReversed',
  ManualTopUp = 'ManualTopUp',
  ManualTopUpReversal = 'ManualTopUpReversal',
  MarketplaceFeePayment = 'MarketplaceFeePayment',
  Payment = 'Payment',
  PaymentFee = 'PaymentFee',
  PaymentFeeReversal = 'PaymentFeeReversal',
  Payout = 'Payout',
  PayoutFee = 'PayoutFee',
  PayoutReversal = 'PayoutReversal',
  Refund = 'Refund',
  Surcharge = 'Surcharge',
  TransactionTransfer = 'TransactionTransfer',
  TransactionTransferFeeReversal = 'TransactionTransferFeeReversal',
  TransactionTransferReversal = 'TransactionTransferReversal'
}

export enum ErrorCode {
  AccountDisabled = 'AccountDisabled',
  AccountNotFound = 'AccountNotFound',
  AudienceMismatch = 'AudienceMismatch',
  BadRequest = 'BadRequest',
  BadSignature = 'BadSignature',
  BankAccountAlreadyVerified = 'BankAccountAlreadyVerified',
  BankAccountNameMissing = 'BankAccountNameMissing',
  BankAccountVerificationFailed = 'BankAccountVerificationFailed',
  BankAccountVerificationNotEnabled = 'BankAccountVerificationNotEnabled',
  CardDeclined = 'CardDeclined',
  ChargeNotFound = 'ChargeNotFound',
  CheckoutApprovalPending = 'CheckoutApprovalPending',
  CheckoutLimitBreached = 'CheckoutLimitBreached',
  CredentialsInvalid = 'CredentialsInvalid',
  CreditCheckRequired = 'CreditCheckRequired',
  CurrencyInvalid = 'CurrencyInvalid',
  CustomerEmailDoesNotMatchRecord = 'CustomerEmailDoesNotMatchRecord',
  CustomerMismatch = 'CustomerMismatch',
  CustomerPhoneNumberDoesNotMatchRecord = 'CustomerPhoneNumberDoesNotMatchRecord',
  DelegateUserExists = 'DelegateUserExists',
  DoNotHonor = 'DoNotHonor',
  DuplicateValue = 'DuplicateValue',
  EmailAlreadyExists = 'EmailAlreadyExists',
  Expired = 'Expired',
  ExpiredCard = 'ExpiredCard',
  Fraudulent = 'Fraudulent',
  HighRiskDetected = 'HighRiskDetected',
  IdMismatch = 'IdMismatch',
  IncorrectCvc = 'IncorrectCvc',
  IncorrectNumber = 'IncorrectNumber',
  InsufficientFunds = 'InsufficientFunds',
  InternalError = 'InternalError',
  InvalidCustomerVerificationCodes = 'InvalidCustomerVerificationCodes',
  InvalidCvc = 'InvalidCvc',
  InvalidDelegateUser = 'InvalidDelegateUser',
  InvalidEmail = 'InvalidEmail',
  InvalidExpiryMonth = 'InvalidExpiryMonth',
  InvalidExpiryYear = 'InvalidExpiryYear',
  InvalidInput = 'InvalidInput',
  InvalidMcc = 'InvalidMcc',
  InvalidTimeRange = 'InvalidTimeRange',
  InvalidToken = 'InvalidToken',
  InvalidVerificationStrategy = 'InvalidVerificationStrategy',
  InvalidVerificationStrategyConfig = 'InvalidVerificationStrategyConfig',
  IssuerMismatch = 'IssuerMismatch',
  KybRequired = 'KybRequired',
  LostCard = 'LostCard',
  MalformedRequest = 'MalformedRequest',
  MarketplaceApiKeyNotFound = 'MarketplaceApiKeyNotFound',
  MarketplaceDisabled = 'MarketplaceDisabled',
  MarketplaceMismatch = 'MarketplaceMismatch',
  MarketplaceNotFound = 'MarketplaceNotFound',
  MarketplaceUserNotFound = 'MarketplaceUserNotFound',
  MerchantEmailInvalid = 'MerchantEmailInvalid',
  MerchantMismatch = 'MerchantMismatch',
  MerchantOrderInvalid = 'MerchantOrderInvalid',
  MerchantSlugInvalid = 'MerchantSlugInvalid',
  MerchantTransferNotFound = 'MerchantTransferNotFound',
  MfaMismatch = 'MfaMismatch',
  NoKycForCustomer = 'NoKycForCustomer',
  NotAllowed = 'NotAllowed',
  NotPermitted = 'NotPermitted',
  OrderPaymentMethodUnavailable = 'OrderPaymentMethodUnavailable',
  OrderStateInvalid = 'OrderStateInvalid',
  OtpRequired = 'OtpRequired',
  PasswordMismatch = 'PasswordMismatch',
  PaymentAmountInvalid = 'PaymentAmountInvalid',
  PaymentAmountMismatch = 'PaymentAmountMismatch',
  PaymentDataInvalid = 'PaymentDataInvalid',
  PaymentNotFound = 'PaymentNotFound',
  PaymentSourceInvalid = 'PaymentSourceInvalid',
  PaymentTokenAlreadyUsed = 'PaymentTokenAlreadyUsed',
  PickupCard = 'PickupCard',
  ProcessingError = 'ProcessingError',
  PublicApiKeyNotFound = 'PublicApiKeyNotFound',
  RefundAmountInvalid = 'RefundAmountInvalid',
  RequesterIdMissing = 'RequesterIdMissing',
  SecretApiKeyNotFound = 'SecretApiKeyNotFound',
  SlugMismatch = 'SlugMismatch',
  StolenCard = 'StolenCard',
  SuspendedMerchantAccount = 'SuspendedMerchantAccount',
  TenantMismatch = 'TenantMismatch',
  TermsAndConditionsNotAccepted = 'TermsAndConditionsNotAccepted',
  TooManyAttempts = 'TooManyAttempts',
  TransactionNotFound = 'TransactionNotFound',
  UnauthorisedPrincipal = 'UnauthorisedPrincipal',
  Unexpected = 'Unexpected',
  UnknownChargeError = 'UnknownChargeError',
  Unspecified = 'Unspecified'
}

export type ExecuteOnExpiry = {
  __typename?: 'ExecuteOnExpiry';
  timestamp: Scalars['Instant']['output'];
};

export type ExpiryDate = {
  __typename?: 'ExpiryDate';
  /** Two digit expiry month, zero padded. */
  expiryMonth: Scalars['String']['output'];
  /** Two digit expiry year. */
  expiryYear: Scalars['String']['output'];
};

export type FailedChallenge = {
  __typename?: 'FailedChallenge';
  acsTransID: OptionString;
  directoryServerTransactionId: OptionString;
  info: OptionString;
  threeDSServerTransID: OptionString;
  transStatus: OptionString;
  transStatusReason: OptionString;
  version: OptionString;
  xid: OptionString;
};

export type FailedFrictionless = {
  __typename?: 'FailedFrictionless';
  acsTransID: OptionString;
  directoryServerTransactionId: OptionString;
  info: OptionString;
  threeDSServerTransID: OptionString;
  transStatus: OptionString;
  transStatusReason: OptionString;
  version: OptionString;
  xid: OptionString;
};

export type FailedTokenized = {
  __typename?: 'FailedTokenized';
  eci: OptionString;
  liabilityShifted: OptionBoolean;
  transStatus: OptionString;
  transStatusReason: OptionString;
};

export type FlowNotAttempted = {
  __typename?: 'FlowNotAttempted';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Issued every second week on the given day of the week. */
export type Fortnightly = {
  __typename?: 'Fortnightly';
  issueDayOfWeek: DayOfWeek;
};

export type FxRateConversion = {
  __typename?: 'FxRateConversion';
  exchangeRate: Scalars['BigDecimal']['output'];
  rateUpdatedAt: Scalars['Instant']['output'];
  sourceAmount: Scalars['BigDecimal']['output'];
  sourceCurrency: Scalars['String']['output'];
  sourceNetAmount?: Maybe<Scalars['BigDecimal']['output']>;
  sourceTaxAmount?: Maybe<Scalars['BigDecimal']['output']>;
  targetAmount?: Maybe<Scalars['BigDecimal']['output']>;
  targetCurrency?: Maybe<Scalars['String']['output']>;
  targetNetAmount?: Maybe<Scalars['BigDecimal']['output']>;
  targetTaxAmount?: Maybe<Scalars['BigDecimal']['output']>;
};

export type HkBankAccountIdentifier = {
  __typename?: 'HkBankAccountIdentifier';
  accountNumber: Scalars['String']['output'];
};

export type HkUsdBankAccountIdentifier = {
  __typename?: 'HkUsdBankAccountIdentifier';
  accountNumber: Scalars['String']['output'];
};

export type IncompleteChallenge = {
  __typename?: 'IncompleteChallenge';
  acsTransID: OptionString;
  acsUrl: OptionString;
  authenticationTransactionId: OptionString;
  challengeUrl: OptionString;
  creq: OptionString;
  directoryServerTransactionId: OptionString;
  info: OptionString;
  internalAuthorisationId: OptionString;
  threeDSServerTransID: OptionString;
  version: OptionString;
  xid: OptionString;
};

export enum Industry {
  AcRefrigerationRepair = 'AcRefrigerationRepair',
  AccountingBookkeepingServices = 'AccountingBookkeepingServices',
  AdvertisingServices = 'AdvertisingServices',
  AgriculturalCooperative = 'AgriculturalCooperative',
  AirlinesAirCarriers = 'AirlinesAirCarriers',
  AirportsFlyingFields = 'AirportsFlyingFields',
  AmbulanceServices = 'AmbulanceServices',
  AmusementParksCarnivals = 'AmusementParksCarnivals',
  AntiqueReproductions = 'AntiqueReproductions',
  AntiqueShops = 'AntiqueShops',
  Aquariums = 'Aquariums',
  ArchitecturalSurveyingServices = 'ArchitecturalSurveyingServices',
  ArtDealersAndGalleries = 'ArtDealersAndGalleries',
  ArtistsSupplyAndCraftShops = 'ArtistsSupplyAndCraftShops',
  AutoAndHomeSupplyStores = 'AutoAndHomeSupplyStores',
  AutoBodyRepairShops = 'AutoBodyRepairShops',
  AutoPaintShops = 'AutoPaintShops',
  AutoServiceShops = 'AutoServiceShops',
  AutomatedCashDisburse = 'AutomatedCashDisburse',
  AutomatedFuelDispensers = 'AutomatedFuelDispensers',
  AutomobileAssociations = 'AutomobileAssociations',
  AutomotivePartsAndAccessoriesStores = 'AutomotivePartsAndAccessoriesStores',
  AutomotiveTireStores = 'AutomotiveTireStores',
  BailAndBondPayments = 'BailAndBondPayments',
  Bakeries = 'Bakeries',
  BandsOrchestras = 'BandsOrchestras',
  BarberAndBeautyShops = 'BarberAndBeautyShops',
  BettingCasinoGambling = 'BettingCasinoGambling',
  BicycleShops = 'BicycleShops',
  BilliardPoolEstablishments = 'BilliardPoolEstablishments',
  BoatDealers = 'BoatDealers',
  BoatRentalsAndLeases = 'BoatRentalsAndLeases',
  BookStores = 'BookStores',
  BooksPeriodicalsAndNewspapers = 'BooksPeriodicalsAndNewspapers',
  BowlingAlleys = 'BowlingAlleys',
  BusLines = 'BusLines',
  BusinessSecretarialSchools = 'BusinessSecretarialSchools',
  BuyingShoppingServices = 'BuyingShoppingServices',
  CableSatelliteAndOtherPayTelevisionAndRadio = 'CableSatelliteAndOtherPayTelevisionAndRadio',
  CameraAndPhotographicSupplyStores = 'CameraAndPhotographicSupplyStores',
  CandyNutAndConfectioneryStores = 'CandyNutAndConfectioneryStores',
  CarAndTruckDealersNewUsed = 'CarAndTruckDealersNewUsed',
  CarAndTruckDealersUsedOnly = 'CarAndTruckDealersUsedOnly',
  CarRentalAgencies = 'CarRentalAgencies',
  CarWashes = 'CarWashes',
  CarpentryServices = 'CarpentryServices',
  CarpetUpholsteryCleaning = 'CarpetUpholsteryCleaning',
  Caterers = 'Caterers',
  CharitableAndSocialServiceOrganizationsFundraising = 'CharitableAndSocialServiceOrganizationsFundraising',
  ChemicalsAndAlliedProducts = 'ChemicalsAndAlliedProducts',
  ChildCareServices = 'ChildCareServices',
  ChildrensAndInfantsWearStores = 'ChildrensAndInfantsWearStores',
  ChiropodistsPodiatrists = 'ChiropodistsPodiatrists',
  Chiropractors = 'Chiropractors',
  CigarStoresAndStands = 'CigarStoresAndStands',
  CivicSocialFraternalAssociations = 'CivicSocialFraternalAssociations',
  CleaningAndMaintenance = 'CleaningAndMaintenance',
  ClothingRental = 'ClothingRental',
  CollegesUniversities = 'CollegesUniversities',
  CommercialEquipment = 'CommercialEquipment',
  CommercialFootwear = 'CommercialFootwear',
  CommercialPhotographyArtAndGraphics = 'CommercialPhotographyArtAndGraphics',
  CommuterTransportAndFerries = 'CommuterTransportAndFerries',
  ComputerNetworkServices = 'ComputerNetworkServices',
  ComputerProgramming = 'ComputerProgramming',
  ComputerRepair = 'ComputerRepair',
  ComputerSoftwareStores = 'ComputerSoftwareStores',
  ComputersPeripheralsAndSoftware = 'ComputersPeripheralsAndSoftware',
  ConcreteWorkServices = 'ConcreteWorkServices',
  ConstructionMaterials = 'ConstructionMaterials',
  ConsultingPublicRelations = 'ConsultingPublicRelations',
  CorrespondenceSchools = 'CorrespondenceSchools',
  CosmeticStores = 'CosmeticStores',
  CounselingServices = 'CounselingServices',
  CountryClubs = 'CountryClubs',
  CourierServices = 'CourierServices',
  CourtCosts = 'CourtCosts',
  CreditReportingAgencies = 'CreditReportingAgencies',
  CruiseLines = 'CruiseLines',
  DairyProductsStores = 'DairyProductsStores',
  DanceHallStudiosSchools = 'DanceHallStudiosSchools',
  DatingEscortServices = 'DatingEscortServices',
  DentistsOrthodontists = 'DentistsOrthodontists',
  DepartmentStores = 'DepartmentStores',
  DetectiveAgencies = 'DetectiveAgencies',
  DigitalGoodsApplications = 'DigitalGoodsApplications',
  DigitalGoodsGames = 'DigitalGoodsGames',
  DigitalGoodsLargeVolume = 'DigitalGoodsLargeVolume',
  DigitalGoodsMedia = 'DigitalGoodsMedia',
  DirectMarketingCatalogMerchant = 'DirectMarketingCatalogMerchant',
  DirectMarketingCombinationCatalogAndRetailMerchant = 'DirectMarketingCombinationCatalogAndRetailMerchant',
  DirectMarketingInboundTelemarketing = 'DirectMarketingInboundTelemarketing',
  DirectMarketingInsuranceServices = 'DirectMarketingInsuranceServices',
  DirectMarketingOther = 'DirectMarketingOther',
  DirectMarketingOutboundTelemarketing = 'DirectMarketingOutboundTelemarketing',
  DirectMarketingSubscription = 'DirectMarketingSubscription',
  DirectMarketingTravel = 'DirectMarketingTravel',
  DiscountStores = 'DiscountStores',
  Doctors = 'Doctors',
  DoorToDoorSales = 'DoorToDoorSales',
  DraperyWindowCoveringAndUpholsteryStores = 'DraperyWindowCoveringAndUpholsteryStores',
  DrinkingPlaces = 'DrinkingPlaces',
  DrugStoresAndPharmacies = 'DrugStoresAndPharmacies',
  DrugsDrugProprietariesAndDruggistSundries = 'DrugsDrugProprietariesAndDruggistSundries',
  DryCleaners = 'DryCleaners',
  DurableGoods = 'DurableGoods',
  DutyFreeStores = 'DutyFreeStores',
  EatingPlacesRestaurants = 'EatingPlacesRestaurants',
  EducationalServices = 'EducationalServices',
  ElectricRazorStores = 'ElectricRazorStores',
  ElectricalPartsAndEquipment = 'ElectricalPartsAndEquipment',
  ElectricalServices = 'ElectricalServices',
  ElectronicsRepairShops = 'ElectronicsRepairShops',
  ElectronicsStores = 'ElectronicsStores',
  ElementarySecondarySchools = 'ElementarySecondarySchools',
  EmploymentTempAgencies = 'EmploymentTempAgencies',
  EquipmentRental = 'EquipmentRental',
  ExterminatingServices = 'ExterminatingServices',
  FamilyClothingStores = 'FamilyClothingStores',
  FastFoodRestaurants = 'FastFoodRestaurants',
  FinancialInstitutions = 'FinancialInstitutions',
  FinesGovernmentAdministrativeEntities = 'FinesGovernmentAdministrativeEntities',
  FireplaceFireplaceScreensAndAccessoriesStores = 'FireplaceFireplaceScreensAndAccessoriesStores',
  FloorCoveringStores = 'FloorCoveringStores',
  Florists = 'Florists',
  FloristsSuppliesNurseryStockAndFlowers = 'FloristsSuppliesNurseryStockAndFlowers',
  FreezerAndLockerMeatProvisioners = 'FreezerAndLockerMeatProvisioners',
  FuelDealersNonAutomotive = 'FuelDealersNonAutomotive',
  FuneralServicesCrematories = 'FuneralServicesCrematories',
  FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances = 'FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances',
  FurnitureRepairRefinishing = 'FurnitureRepairRefinishing',
  FurriersAndFurShops = 'FurriersAndFurShops',
  GeneralServices = 'GeneralServices',
  GiftCardNoveltyAndSouvenirShops = 'GiftCardNoveltyAndSouvenirShops',
  GlassPaintAndWallpaperStores = 'GlassPaintAndWallpaperStores',
  GlasswareCrystalStores = 'GlasswareCrystalStores',
  GolfCoursesPublic = 'GolfCoursesPublic',
  GovernmentServices = 'GovernmentServices',
  GroceryStoresSupermarkets = 'GroceryStoresSupermarkets',
  HardwareEquipmentAndSupplies = 'HardwareEquipmentAndSupplies',
  HardwareStores = 'HardwareStores',
  HealthAndBeautySpas = 'HealthAndBeautySpas',
  HearingAidsSalesAndSupplies = 'HearingAidsSalesAndSupplies',
  HeatingPlumbingAc = 'HeatingPlumbingAC',
  HobbyToyAndGameShops = 'HobbyToyAndGameShops',
  HomeSupplyWarehouseStores = 'HomeSupplyWarehouseStores',
  Hospitals = 'Hospitals',
  HotelsMotelsAndResorts = 'HotelsMotelsAndResorts',
  HouseholdApplianceStores = 'HouseholdApplianceStores',
  IndustrialSupplies = 'IndustrialSupplies',
  InformationRetrievalServices = 'InformationRetrievalServices',
  InsuranceDefault = 'InsuranceDefault',
  InsuranceUnderwritingPremiums = 'InsuranceUnderwritingPremiums',
  IntraCompanyPurchases = 'IntraCompanyPurchases',
  JewelryStoresWatchesClocksAndSilverwareStores = 'JewelryStoresWatchesClocksAndSilverwareStores',
  LandscapingServices = 'LandscapingServices',
  Laundries = 'Laundries',
  LaundryCleaningServices = 'LaundryCleaningServices',
  LegalServicesAttorneys = 'LegalServicesAttorneys',
  LuggageAndLeatherGoodsStores = 'LuggageAndLeatherGoodsStores',
  LumberBuildingMaterialsStores = 'LumberBuildingMaterialsStores',
  ManualCashDisburse = 'ManualCashDisburse',
  MarinasServiceAndSupplies = 'MarinasServiceAndSupplies',
  MasonryStoneworkAndPlaster = 'MasonryStoneworkAndPlaster',
  MassageParlors = 'MassageParlors',
  MedicalAndDentalLabs = 'MedicalAndDentalLabs',
  MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies = 'MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies',
  MedicalServices = 'MedicalServices',
  MembershipOrganizations = 'MembershipOrganizations',
  MensAndBoysClothingAndAccessoriesStores = 'MensAndBoysClothingAndAccessoriesStores',
  MensWomensClothingStores = 'MensWomensClothingStores',
  MetalServiceCenters = 'MetalServiceCenters',
  MiscellaneousApparelAndAccessoryShops = 'MiscellaneousApparelAndAccessoryShops',
  MiscellaneousAutoDealers = 'MiscellaneousAutoDealers',
  MiscellaneousBusinessServices = 'MiscellaneousBusinessServices',
  MiscellaneousFoodStores = 'MiscellaneousFoodStores',
  MiscellaneousGeneralMerchandise = 'MiscellaneousGeneralMerchandise',
  MiscellaneousGeneralServices = 'MiscellaneousGeneralServices',
  MiscellaneousHomeFurnishingSpecialtyStores = 'MiscellaneousHomeFurnishingSpecialtyStores',
  MiscellaneousPublishingAndPrinting = 'MiscellaneousPublishingAndPrinting',
  MiscellaneousRecreationServices = 'MiscellaneousRecreationServices',
  MiscellaneousRepairShops = 'MiscellaneousRepairShops',
  MiscellaneousSpecialtyRetail = 'MiscellaneousSpecialtyRetail',
  MobileHomeDealers = 'MobileHomeDealers',
  MotionPictureTheaters = 'MotionPictureTheaters',
  MotorFreightCarriersAndTrucking = 'MotorFreightCarriersAndTrucking',
  MotorHomesDealers = 'MotorHomesDealers',
  MotorVehicleSuppliesAndNewParts = 'MotorVehicleSuppliesAndNewParts',
  MotorcycleShopsAndDealers = 'MotorcycleShopsAndDealers',
  MotorcycleShopsDealers = 'MotorcycleShopsDealers',
  MusicStoresMusicalInstrumentsPianosAndSheetMusic = 'MusicStoresMusicalInstrumentsPianosAndSheetMusic',
  NewsDealersAndNewsstands = 'NewsDealersAndNewsstands',
  NonFiMoneyOrders = 'NonFiMoneyOrders',
  NonFiStoredValueCardPurchaseLoad = 'NonFiStoredValueCardPurchaseLoad',
  NondurableGoods = 'NondurableGoods',
  NurseriesLawnAndGardenSupplyStores = 'NurseriesLawnAndGardenSupplyStores',
  NursingPersonalCare = 'NursingPersonalCare',
  OfficeAndCommercialFurniture = 'OfficeAndCommercialFurniture',
  OpticiansEyeglasses = 'OpticiansEyeglasses',
  OptometristsOphthalmologist = 'OptometristsOphthalmologist',
  OrthopedicGoodsProstheticDevices = 'OrthopedicGoodsProstheticDevices',
  Osteopaths = 'Osteopaths',
  PackageStoresBeerWineAndLiquor = 'PackageStoresBeerWineAndLiquor',
  PaintsVarnishesAndSupplies = 'PaintsVarnishesAndSupplies',
  ParkingLotsGarages = 'ParkingLotsGarages',
  PassengerRailways = 'PassengerRailways',
  PawnShops = 'PawnShops',
  PetShopsPetFoodAndSupplies = 'PetShopsPetFoodAndSupplies',
  PetroleumAndPetroleumProducts = 'PetroleumAndPetroleumProducts',
  PhotoDeveloping = 'PhotoDeveloping',
  PhotographicPhotocopyMicrofilmEquipmentAndSupplies = 'PhotographicPhotocopyMicrofilmEquipmentAndSupplies',
  PhotographicStudios = 'PhotographicStudios',
  PictureVideoProduction = 'PictureVideoProduction',
  PieceGoodsNotionsAndOtherDryGoods = 'PieceGoodsNotionsAndOtherDryGoods',
  PlumbingHeatingEquipmentAndSupplies = 'PlumbingHeatingEquipmentAndSupplies',
  PoliticalOrganizations = 'PoliticalOrganizations',
  PostalServicesGovernmentOnly = 'PostalServicesGovernmentOnly',
  PreciousStonesAndMetalsWatchesAndJewelry = 'PreciousStonesAndMetalsWatchesAndJewelry',
  ProfessionalServices = 'ProfessionalServices',
  PublicWarehousingAndStorage = 'PublicWarehousingAndStorage',
  QuickCopyReproAndBlueprint = 'QuickCopyReproAndBlueprint',
  Railroads = 'Railroads',
  RealEstateAgentsAndManagersRentals = 'RealEstateAgentsAndManagersRentals',
  RecordStores = 'RecordStores',
  RecreationalVehicleRentals = 'RecreationalVehicleRentals',
  ReligiousGoodsStores = 'ReligiousGoodsStores',
  ReligiousOrganizations = 'ReligiousOrganizations',
  RoofingSidingSheetMetal = 'RoofingSidingSheetMetal',
  SecretarialSupportServices = 'SecretarialSupportServices',
  SecurityBrokersDealers = 'SecurityBrokersDealers',
  ServiceStations = 'ServiceStations',
  SewingNeedleworkFabricAndPieceGoodsStores = 'SewingNeedleworkFabricAndPieceGoodsStores',
  ShoeRepairHatCleaning = 'ShoeRepairHatCleaning',
  ShoeStores = 'ShoeStores',
  SmallApplianceRepair = 'SmallApplianceRepair',
  SnowmobileDealers = 'SnowmobileDealers',
  SpecialTradeServices = 'SpecialTradeServices',
  SpecialtyCleaning = 'SpecialtyCleaning',
  SportingGoodsStores = 'SportingGoodsStores',
  SportingRecreationCamps = 'SportingRecreationCamps',
  SportsAndRidingApparelStores = 'SportsAndRidingApparelStores',
  SportsClubsFields = 'SportsClubsFields',
  StampAndCoinStores = 'StampAndCoinStores',
  StationaryOfficeSuppliesPrintingAndWritingPaper = 'StationaryOfficeSuppliesPrintingAndWritingPaper',
  StationeryStoresOfficeAndSchoolSupplyStores = 'StationeryStoresOfficeAndSchoolSupplyStores',
  SwimmingPoolsSales = 'SwimmingPoolsSales',
  TUiTravelGermany = 'TUiTravelGermany',
  TailorsAlterations = 'TailorsAlterations',
  TaxPaymentsGovernmentAgencies = 'TaxPaymentsGovernmentAgencies',
  TaxPreparationServices = 'TaxPreparationServices',
  TaxicabsLimousines = 'TaxicabsLimousines',
  TelecommunicationEquipmentAndTelephoneSales = 'TelecommunicationEquipmentAndTelephoneSales',
  TelecommunicationServices = 'TelecommunicationServices',
  TelegraphServices = 'TelegraphServices',
  TentAndAwningShops = 'TentAndAwningShops',
  TestingLaboratories = 'TestingLaboratories',
  TheatricalTicketAgencies = 'TheatricalTicketAgencies',
  Timeshares = 'Timeshares',
  TireRetreadingAndRepair = 'TireRetreadingAndRepair',
  TollsBridgeFees = 'TollsBridgeFees',
  TouristAttractionsAndExhibits = 'TouristAttractionsAndExhibits',
  TowingServices = 'TowingServices',
  TrailerParksCampgrounds = 'TrailerParksCampgrounds',
  TransportationServices = 'TransportationServices',
  TravelAgenciesTourOperators = 'TravelAgenciesTourOperators',
  TruckStopIteration = 'TruckStopIteration',
  TruckUtilityTrailerRentals = 'TruckUtilityTrailerRentals',
  TypesettingPlateMakingAndRelatedServices = 'TypesettingPlateMakingAndRelatedServices',
  TypewriterStores = 'TypewriterStores',
  UsFederalGovernmentAgenciesOrDepartments = 'USFederalGovernmentAgenciesOrDepartments',
  UniformsCommercialClothing = 'UniformsCommercialClothing',
  UsedMerchandiseAndSecondhandStores = 'UsedMerchandiseAndSecondhandStores',
  Utilities = 'Utilities',
  VarietyStores = 'VarietyStores',
  VeterinaryServices = 'VeterinaryServices',
  VideoAmusementGameSupplies = 'VideoAmusementGameSupplies',
  VideoGameArcades = 'VideoGameArcades',
  VideoTapeRentalStores = 'VideoTapeRentalStores',
  VocationalTradeSchools = 'VocationalTradeSchools',
  WatchJewelryRepair = 'WatchJewelryRepair',
  WeldingRepair = 'WeldingRepair',
  WholesaleClubs = 'WholesaleClubs',
  WigAndToupeeStores = 'WigAndToupeeStores',
  WiresMoneyOrders = 'WiresMoneyOrders',
  WomensAccessoryAndSpecialtyShops = 'WomensAccessoryAndSpecialtyShops',
  WomensReadyToWearStores = 'WomensReadyToWearStores',
  WreckingAndSalvageYards = 'WreckingAndSalvageYards'
}

export enum IndustryGroup {
  Procurement = 'Procurement',
  Travel = 'Travel'
}

export type InstantFilterInput = {
  /** Value is greater than the given timestamp in ISO-8601 format (e.g. '2024-09-02T17:18:14.828392+10:00'). */
  gt?: InputMaybe<Scalars['Instant']['input']>;
  /** Value is greater than or equal to the given timestamp in ISO-8601 format. */
  gte?: InputMaybe<Scalars['Instant']['input']>;
  /** Value is less than the given timestamp in ISO-8601 format. */
  lt?: InputMaybe<Scalars['Instant']['input']>;
  /** Value is less than or equal to the given timestamp in ISO-8601 format. */
  lte?: InputMaybe<Scalars['Instant']['input']>;
};

export type InvalidField = {
  __typename?: 'InvalidField';
  issues: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requiredStatementStatus: RequiredStatus;
  requiredTransactionStatus: RequiredStatus;
  value?: Maybe<Scalars['String']['output']>;
};

export enum IsoCountry {
  Afghanistan = 'AFGHANISTAN',
  AlandIslands = 'ALAND_ISLANDS',
  Albania = 'ALBANIA',
  Algeria = 'ALGERIA',
  AmericanSamoa = 'AMERICAN_SAMOA',
  Andorra = 'ANDORRA',
  Angola = 'ANGOLA',
  Anguilla = 'ANGUILLA',
  Antarctica = 'ANTARCTICA',
  AntiguaAndBarbuda = 'ANTIGUA_AND_BARBUDA',
  Argentina = 'ARGENTINA',
  Armenia = 'ARMENIA',
  Aruba = 'ARUBA',
  Australia = 'AUSTRALIA',
  Austria = 'AUSTRIA',
  Azerbaijan = 'AZERBAIJAN',
  Bahamas = 'BAHAMAS',
  Bahrain = 'BAHRAIN',
  Bangladesh = 'BANGLADESH',
  Barbados = 'BARBADOS',
  Belarus = 'BELARUS',
  Belgium = 'BELGIUM',
  Belize = 'BELIZE',
  Benin = 'BENIN',
  Bermuda = 'BERMUDA',
  Bhutan = 'BHUTAN',
  Bolivia = 'BOLIVIA',
  Bonaire = 'BONAIRE',
  BosniaAndHerzegovina = 'BOSNIA_AND_HERZEGOVINA',
  Botswana = 'BOTSWANA',
  BouvetIsland = 'BOUVET_ISLAND',
  Brazil = 'BRAZIL',
  BritishIndianOceanTerritory = 'BRITISH_INDIAN_OCEAN_TERRITORY',
  BritishVirginIslands = 'BRITISH_VIRGIN_ISLANDS',
  BruneiDarussalam = 'BRUNEI_DARUSSALAM',
  Bulgaria = 'BULGARIA',
  BurkinaFaso = 'BURKINA_FASO',
  Burundi = 'BURUNDI',
  Cambodia = 'CAMBODIA',
  Cameroon = 'CAMEROON',
  Canada = 'CANADA',
  CapeVerde = 'CAPE_VERDE',
  CaymanIslands = 'CAYMAN_ISLANDS',
  CentralAfricanRepublic = 'CENTRAL_AFRICAN_REPUBLIC',
  Chad = 'CHAD',
  Chile = 'CHILE',
  China = 'CHINA',
  ChristmasIsland = 'CHRISTMAS_ISLAND',
  CocosIslands = 'COCOS_ISLANDS',
  Colombia = 'COLOMBIA',
  Comoros = 'COMOROS',
  Congo = 'CONGO',
  CookIslands = 'COOK_ISLANDS',
  CostaRica = 'COSTA_RICA',
  CoteDIvoire = 'COTE_D_IVOIRE',
  Croatia = 'CROATIA',
  Cuba = 'CUBA',
  Curacao = 'CURACAO',
  Cyprus = 'CYPRUS',
  CzechRepublic = 'CZECH_REPUBLIC',
  Denmark = 'DENMARK',
  Djibouti = 'DJIBOUTI',
  Dominica = 'DOMINICA',
  DominicanRepublic = 'DOMINICAN_REPUBLIC',
  Ecuador = 'ECUADOR',
  Egypt = 'EGYPT',
  ElSalvador = 'EL_SALVADOR',
  EquatorialGuinea = 'EQUATORIAL_GUINEA',
  Eritrea = 'ERITREA',
  Estonia = 'ESTONIA',
  Ethiopia = 'ETHIOPIA',
  FalklandIslands = 'FALKLAND_ISLANDS',
  FaroeIslands = 'FAROE_ISLANDS',
  Fiji = 'FIJI',
  Finland = 'FINLAND',
  France = 'FRANCE',
  FrenchGuiana = 'FRENCH_GUIANA',
  FrenchPolynesia = 'FRENCH_POLYNESIA',
  FrenchSouthernTerritories = 'FRENCH_SOUTHERN_TERRITORIES',
  Gabon = 'GABON',
  Gambia = 'GAMBIA',
  Georgia = 'GEORGIA',
  Germany = 'GERMANY',
  Ghana = 'GHANA',
  Gibraltar = 'GIBRALTAR',
  Greece = 'GREECE',
  Greenland = 'GREENLAND',
  Grenada = 'GRENADA',
  Guadeloupe = 'GUADELOUPE',
  Guam = 'GUAM',
  Guatemala = 'GUATEMALA',
  Guernsey = 'GUERNSEY',
  Guinea = 'GUINEA',
  GuineaBissau = 'GUINEA_BISSAU',
  Guyana = 'GUYANA',
  Haiti = 'HAITI',
  HeardIslandAndMcdonaldIslands = 'HEARD_ISLAND_AND_MCDONALD_ISLANDS',
  Honduras = 'HONDURAS',
  HongKong = 'HONG_KONG',
  Hungary = 'HUNGARY',
  Iceland = 'ICELAND',
  India = 'INDIA',
  Indonesia = 'INDONESIA',
  Iran = 'IRAN',
  Iraq = 'IRAQ',
  Ireland = 'IRELAND',
  IsleOfMan = 'ISLE_OF_MAN',
  Israel = 'ISRAEL',
  Italy = 'ITALY',
  Jamaica = 'JAMAICA',
  Japan = 'JAPAN',
  Jersey = 'JERSEY',
  Jordan = 'JORDAN',
  Kazakhstan = 'KAZAKHSTAN',
  Kenya = 'KENYA',
  Kiribati = 'KIRIBATI',
  Kuwait = 'KUWAIT',
  Kyrgyzstan = 'KYRGYZSTAN',
  LaoPeoplesDemocraticRepublic = 'LAO_PEOPLES_DEMOCRATIC_REPUBLIC',
  Latvia = 'LATVIA',
  Lebanon = 'LEBANON',
  Lesotho = 'LESOTHO',
  Liberia = 'LIBERIA',
  Libya = 'LIBYA',
  Liechtenstein = 'LIECHTENSTEIN',
  Lithuania = 'LITHUANIA',
  Luxembourg = 'LUXEMBOURG',
  Macao = 'MACAO',
  Macedonia = 'MACEDONIA',
  Madagascar = 'MADAGASCAR',
  Malawi = 'MALAWI',
  Malaysia = 'MALAYSIA',
  Maldives = 'MALDIVES',
  Mali = 'MALI',
  Malta = 'MALTA',
  MarshallIslands = 'MARSHALL_ISLANDS',
  Martinique = 'MARTINIQUE',
  Mauritania = 'MAURITANIA',
  Mauritius = 'MAURITIUS',
  Mayotte = 'MAYOTTE',
  Mexico = 'MEXICO',
  Micronesia = 'MICRONESIA',
  Moldova = 'MOLDOVA',
  Monaco = 'MONACO',
  Mongolia = 'MONGOLIA',
  Montenegro = 'MONTENEGRO',
  Montserrat = 'MONTSERRAT',
  Morocco = 'MOROCCO',
  Mozambique = 'MOZAMBIQUE',
  Myanmar = 'MYANMAR',
  Namibia = 'NAMIBIA',
  Nauru = 'NAURU',
  Nepal = 'NEPAL',
  Netherlands = 'NETHERLANDS',
  NewCaledonia = 'NEW_CALEDONIA',
  NewZealand = 'NEW_ZEALAND',
  Nicaragua = 'NICARAGUA',
  Niger = 'NIGER',
  Nigeria = 'NIGERIA',
  Niue = 'NIUE',
  NorfolkIsland = 'NORFOLK_ISLAND',
  NorthernMarianaIslands = 'NORTHERN_MARIANA_ISLANDS',
  NorthKorea = 'NORTH_KOREA',
  Norway = 'NORWAY',
  Oman = 'OMAN',
  Pakistan = 'PAKISTAN',
  Palau = 'PALAU',
  Palestine = 'PALESTINE',
  Panama = 'PANAMA',
  PapuaNewGuinea = 'PAPUA_NEW_GUINEA',
  Paraguay = 'PARAGUAY',
  Peru = 'PERU',
  Philippines = 'PHILIPPINES',
  Pitcairn = 'PITCAIRN',
  Poland = 'POLAND',
  Portugal = 'PORTUGAL',
  PuertoRico = 'PUERTO_RICO',
  Qatar = 'QATAR',
  Reunion = 'REUNION',
  Romania = 'ROMANIA',
  RussianFederation = 'RUSSIAN_FEDERATION',
  Rwanda = 'RWANDA',
  SaintBarthelemy = 'SAINT_BARTHELEMY',
  SaintHelena = 'SAINT_HELENA',
  SaintKittsAndNevis = 'SAINT_KITTS_AND_NEVIS',
  SaintLucia = 'SAINT_LUCIA',
  SaintMartin = 'SAINT_MARTIN',
  SaintPierreAndMiquelon = 'SAINT_PIERRE_AND_MIQUELON',
  SaintVincentAndTheGrenadines = 'SAINT_VINCENT_AND_THE_GRENADINES',
  Samoa = 'SAMOA',
  SanMarino = 'SAN_MARINO',
  SaoTomeAndPrincipe = 'SAO_TOME_AND_PRINCIPE',
  SaudiArabia = 'SAUDI_ARABIA',
  Senegal = 'SENEGAL',
  Serbia = 'SERBIA',
  Seychelles = 'SEYCHELLES',
  SierraLeone = 'SIERRA_LEONE',
  Singapore = 'SINGAPORE',
  SintMaarten = 'SINT_MAARTEN',
  Slovakia = 'SLOVAKIA',
  Slovenia = 'SLOVENIA',
  SolomonIslands = 'SOLOMON_ISLANDS',
  Somalia = 'SOMALIA',
  SouthAfrica = 'SOUTH_AFRICA',
  SouthGeorgiaAndTheSouthSandwichIslands = 'SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS',
  SouthKorea = 'SOUTH_KOREA',
  SouthSudan = 'SOUTH_SUDAN',
  Spain = 'SPAIN',
  SriLanka = 'SRI_LANKA',
  Sudan = 'SUDAN',
  Suriname = 'SURINAME',
  SvalbardAndJanMayen = 'SVALBARD_AND_JAN_MAYEN',
  Swaziland = 'SWAZILAND',
  Sweden = 'SWEDEN',
  Switzerland = 'SWITZERLAND',
  SyrianArabRepublic = 'SYRIAN_ARAB_REPUBLIC',
  Taiwan = 'TAIWAN',
  Tajikistan = 'TAJIKISTAN',
  Tanzania = 'TANZANIA',
  Thailand = 'THAILAND',
  TheDemocraticRepublicOfTheCongo = 'THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
  TimorLeste = 'TIMOR_LESTE',
  Togo = 'TOGO',
  Tokelau = 'TOKELAU',
  Tonga = 'TONGA',
  TrinidadAndTobago = 'TRINIDAD_AND_TOBAGO',
  Tunisia = 'TUNISIA',
  Turkey = 'TURKEY',
  Turkmenistan = 'TURKMENISTAN',
  TurksAndCaicosIslands = 'TURKS_AND_CAICOS_ISLANDS',
  Tuvalu = 'TUVALU',
  Uganda = 'UGANDA',
  Ukraine = 'UKRAINE',
  UnitedArabEmirates = 'UNITED_ARAB_EMIRATES',
  UnitedKingdom = 'UNITED_KINGDOM',
  UnitedStates = 'UNITED_STATES',
  UnitedStatesMinorOutlyingIslands = 'UNITED_STATES_MINOR_OUTLYING_ISLANDS',
  Uruguay = 'URUGUAY',
  UsVirginIslands = 'US_VIRGIN_ISLANDS',
  Uzbekistan = 'UZBEKISTAN',
  Vanuatu = 'VANUATU',
  VaticanCityState = 'VATICAN_CITY_STATE',
  Venezuela = 'VENEZUELA',
  VietNam = 'VIET_NAM',
  WallisAndFutuna = 'WALLIS_AND_FUTUNA',
  WesternSahara = 'WESTERN_SAHARA',
  Yemen = 'YEMEN',
  Zambia = 'ZAMBIA',
  Zimbabwe = 'ZIMBABWE'
}

export type IsoCurrencyAmount = {
  __typename?: 'IsoCurrencyAmount';
  currency: Scalars['String']['output'];
  minorCurrencyUnits: Scalars['Long']['output'];
};

export enum IssuerCardBrand {
  Mastercard = 'Mastercard',
  Uatp = 'UATP'
}

export enum IssuerEventType {
  ManualAdjustment = 'ManualAdjustment',
  PaymentAuthorised = 'PaymentAuthorised',
  PaymentCancelled = 'PaymentCancelled',
  PaymentDisputeLost = 'PaymentDisputeLost',
  PaymentDisputeWon = 'PaymentDisputeWon',
  PaymentDisputed = 'PaymentDisputed',
  PaymentFailed = 'PaymentFailed',
  PaymentRefunded = 'PaymentRefunded',
  PaymentSucceed = 'PaymentSucceed'
}

export enum IssuerNetworkType {
  ClosedLoop = 'ClosedLoop',
  OpenLoop = 'OpenLoop'
}

/** For issuer transactions, the mechanism used to settle with the merchant. */
export enum IssuerSettlementType {
  ClosedLoop = 'ClosedLoop',
  OpenLoop = 'OpenLoop'
}

export type IssuerTransactionNode = {
  __typename?: 'IssuerTransactionNode';
  acquiringMerchantDetails: MerchantDetails;
  borrowerCustomer?: Maybe<MerchantCustomerNode>;
  borrowerMerchant?: Maybe<MerchantNode>;
  createdAt: Scalars['Instant']['output'];
  /** The digital card the transaction was made on, if any. */
  digitalCard?: Maybe<DigitalCardNode>;
  /** System unique identifier for the transaction representing this payment. */
  issuerTransactionId: Scalars['String']['output'];
  /** The loan this transaction was drawn down against, if any. */
  loan?: Maybe<LoanNode>;
  /** The loan transaction this issuer transaction was recorded as, if any. */
  loanTransactionId?: Maybe<Scalars['String']['output']>;
  /** Linked transactions are always published in the same customer invoice. */
  parentTransactionId?: Maybe<Scalars['String']['output']>;
  paymentDetails: PaymentDetails;
  purchaseDetails: PurchaseDetails;
  timelines: Array<IssuerTransactionTimeLine>;
};

export type IssuerTransactionSearchConnection = {
  __typename?: 'IssuerTransactionSearchConnection';
  edges: Array<IssuerTransactionSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type IssuerTransactionSearchEdge = {
  __typename?: 'IssuerTransactionSearchEdge';
  cursor: Scalars['String']['output'];
  node: IssuerTransactionNode;
};

export enum IssuerTransactionSearchOrderField {
  CapturedAt = 'CapturedAt',
  CreatedAt = 'CreatedAt',
  /** Order by when the transaction became publicly visible. */
  PublicAt = 'PublicAt',
  PublishedAt = 'PublishedAt',
  SalesDate = 'SalesDate',
  /** Order by when the transaction was transacted. */
  TransactedAt = 'TransactedAt'
}

export type IssuerTransactionSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: IssuerTransactionSearchOrderField;
};

export type IssuerTransactionTimeLine = {
  __typename?: 'IssuerTransactionTimeLine';
  amount?: Maybe<Scalars['Long']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventTime: Scalars['Instant']['output'];
  eventType: IssuerEventType;
  identifier?: Maybe<Scalars['String']['output']>;
};

export type Item = {
  __typename?: 'Item';
  amount: IsoCurrencyAmount;
  description: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['BigDecimal']['output'];
  sku?: Maybe<Scalars['String']['output']>;
};

/** A key-value pair of String and InvalidField */
export type KvStringInvalidField = {
  __typename?: 'KVStringInvalidField';
  /** Key */
  key: Scalars['String']['output'];
  /** Value */
  value: InvalidField;
};

/** All possible types of loan statement line item. */
export enum LineItemEntryType {
  AnnualFee = 'AnnualFee',
  BankFee = 'BankFee',
  Charge = 'Charge',
  CurrencyConversionFee = 'CurrencyConversionFee',
  Dispute = 'Dispute',
  DisputeFee = 'DisputeFee',
  HotelEnrichmentFee = 'HotelEnrichmentFee',
  ImplementationFee = 'ImplementationFee',
  Insurance = 'Insurance',
  InternationalProcessingFee = 'InternationalProcessingFee',
  LatePaymentFee = 'LatePaymentFee',
  LatePaymentReminderFee = 'LatePaymentReminderFee',
  ManualAdjustment = 'ManualAdjustment',
  PremiumAccountFee = 'PremiumAccountFee',
  Refund = 'Refund',
  StatementReissueFee = 'StatementReissueFee',
  ThirdPartyServiceFee = 'ThirdPartyServiceFee',
  TransactionFee = 'TransactionFee'
}

export type LoanBalances = {
  __typename?: 'LoanBalances';
  /** The maximum amount that can be owed at any point. */
  accountLimit: Scalars['Long']['output'];
  /** The amount available for draw down from the loan in minor currency units. */
  availableBalance: Scalars['Long']['output'];
  /** Repayments in minor currency units where the corresponding funds have yet to settle. */
  pendingBalance: Scalars['Long']['output'];
  /** Loan transactions that have yet to appear on a customer statement in minor currency units. */
  reservedBalance: Scalars['Long']['output'];
  /** The amount currently outstanding in customer statements in minor currency units. */
  usedBalance: Scalars['Long']['output'];
};

export type LoanCustomerFees = {
  __typename?: 'LoanCustomerFees';
  /** Fee automatically charged to the account annually, specified in major currency units. */
  annualFixedFee: Scalars['Long']['output'];
  /** Rate charged to convert drawdowns in foreign currencies to the settlement currency. */
  currencyConversionVariableFee: Scalars['BigDecimal']['output'];
  /** Fee attached to every hotel transaction. */
  hotelEnrichmentFixedFee?: Maybe<Scalars['Long']['output']>;
  /** One off fee charged when the loan is established, specified in major currency units. */
  implementationFixedFee?: Maybe<Scalars['Long']['output']>;
  /** Rate charged when a Mastercard transaction is processed outside the market of the service agreement. */
  internationalProcessingVariableFee: Scalars['BigDecimal']['output'];
  /** Late payment fees chargeable on overdue amounts, at a percentage cost on an annualised basis. */
  latePaymentInterestVariableFee: Scalars['BigDecimal']['output'];
  /** Fee charged if the account payment is not made on time and a reminder letter needs to be sent. */
  latePaymentReminderFixedFee: Scalars['Long']['output'];
  /** Rate added to all charges for premium accounts, specified as a decimal (e.g. 0.05 for 5%). */
  premiumAccountVariableFee?: Maybe<Scalars['BigDecimal']['output']>;
  /** Fee charged to re-issue a statement via email. */
  statementReissueFixedFee: Scalars['Long']['output'];
  /** Fee attached to every transaction. */
  transactionFixedFee?: Maybe<Scalars['Long']['output']>;
};

export type LoanFxRateConversion = {
  __typename?: 'LoanFxRateConversion';
  /** The rate to convert one unit of the source currency to the target currency. */
  exchangeRate: Scalars['BigDecimal']['output'];
  /** When the exchange rate was set. */
  rateUpdatedAt: Scalars['Instant']['output'];
  /** Gross amount in major units of the source currency. */
  sourceAmount: Scalars['BigDecimal']['output'];
  /** Original currency the entry was specified in. */
  sourceCurrency: Scalars['String']['output'];
  /** Net amount in major units of the source currency. */
  sourceNetAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Tax amount in major units of the source currency. */
  sourceTaxAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Gross amount in major units of the target currency. */
  targetAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Currency converted into. */
  targetCurrency?: Maybe<Scalars['String']['output']>;
  /** Net amount in major units of the target currency. */
  targetNetAmount?: Maybe<Scalars['BigDecimal']['output']>;
  /** Tax amount in major units of the target currency. */
  targetTaxAmount?: Maybe<Scalars['BigDecimal']['output']>;
};

export type LoanNode = {
  __typename?: 'LoanNode';
  balances: LoanBalances;
  /** Payment source used for automated payments of loan statements, if any. */
  billingPaymentSourceId?: Maybe<Scalars['String']['output']>;
  /** The marketplace associated with the borrowing merchant, if any. */
  borrowerMarketplaceId?: Maybe<Scalars['String']['output']>;
  /** The merchant borrowing against this loan. */
  borrowerMerchant?: Maybe<MerchantNode>;
  /** When the loan was created, in the loan's timezone. */
  createdAt: Scalars['OffsetDateTime']['output'];
  /** The currency of the loan. */
  currency: Currency;
  /** The human readable name associated with this loan. */
  loanAccountName: Scalars['String']['output'];
  /** System identifier for the loan facility providing the loan product. */
  loanFacilityId: Scalars['String']['output'];
  /** System unique identifier for the loan. */
  loanId: Scalars['String']['output'];
  /** The master agreement linked to this loan, if any. */
  loanMasterAgreementId?: Maybe<Scalars['String']['output']>;
  /** Metadata associated with this loan, if any. */
  loanMetadata?: Maybe<Scalars['String']['output']>;
  /** System identifier for the loan product for this loan. */
  loanProductId: Scalars['String']['output'];
  /** A reference provided by the applicant to identify this loan. */
  referenceLoanId?: Maybe<Scalars['String']['output']>;
  specification: LoanSpecification;
  /** The status of the loan. */
  status: LoanStatus;
  /** Timezone of the loan, used to determine statement time windows and for reporting. */
  timeZone: Scalars['String']['output'];
  /** When the loan was last updated, in the loan's timezone. */
  updatedAt: Scalars['OffsetDateTime']['output'];
};

export enum LoanProductType {
  RealtimeSettlement = 'RealtimeSettlement',
  TradingAccount = 'TradingAccount'
}

export type LoanSearchConnection = {
  __typename?: 'LoanSearchConnection';
  edges: Array<LoanSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type LoanSearchEdge = {
  __typename?: 'LoanSearchEdge';
  cursor: Scalars['String']['output'];
  node: LoanNode;
};

export enum LoanSearchOrderField {
  /** Order by when the loan was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type LoanSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: LoanSearchOrderField;
};

export type LoanSpecification = RealtimeSettlementLoanSpecification | TradingAccountLoanSpecification;

export type LoanStatementEntryNode = {
  __typename?: 'LoanStatementEntryNode';
  acquiringMerchantDetails: MerchantDetails;
  /** Full amount this entry contributes to the statement, in minor currency units. */
  billingAmountTotal: Scalars['Long']['output'];
  /** Currency of the statement amounts. */
  currency: Currency;
  digitalCardDetails?: Maybe<DigitalCardDetails>;
  /** A human-readable description of the statement entry. */
  entryDescription: Scalars['String']['output'];
  /** System identifier specific to the given entry type. */
  entryId?: Maybe<Scalars['String']['output']>;
  /** When the statement line was recorded. */
  entryTimestamp: Scalars['OffsetDateTime']['output'];
  /** Type of loan statement entry. */
  entryType: LoanStatementEntryType;
  /** Combination of all insurance-related line items, in minor currency units. */
  insuranceTotal: Scalars['Long']['output'];
  /** For issuer transactions, the mechanism used to settle with the merchant. */
  issuerSettlementType?: Maybe<IssuerSettlementType>;
  /** The issuer transaction associated with this entry, if any. */
  issuerTransactionId?: Maybe<Scalars['String']['output']>;
  /** Statement line items associated with this entry. Always at least one. */
  lineItems: Array<LoanStatementLineItem>;
  /** System identifier for the loan. */
  loanId: Scalars['String']['output'];
  /** The statement this entry is included in. Empty only if the statement has not yet been issued. */
  loanStatementId?: Maybe<Scalars['String']['output']>;
  /** Metadata associated with this entry, if any. */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Sum of all line items before tax and insurance, in minor currency units. */
  netTotal: Scalars['Long']['output'];
  /** Details of the FX conversion from the charge currency to the billing currency. */
  originalBillingAmountTotal: LoanFxRateConversion;
  /** Customer-visible identifier for the statement this entry is included in. */
  referenceStatementId?: Maybe<Scalars['String']['output']>;
  supplierDetails: LoanStatementSupplierDetails;
  /** The tax rate applied, as a rate — 0.1 represents 10% tax. */
  taxRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Combined tax from all line items, in minor currency units. */
  taxTotal: Scalars['Long']['output'];
  /** Name for the tax being applied. */
  taxType?: Maybe<Scalars['String']['output']>;
  /** The acquiring transaction associated with this entry, if any. */
  transactionId?: Maybe<Scalars['String']['output']>;
};

export enum LoanStatementEntryType {
  Adjustment = 'Adjustment',
  Charge = 'Charge',
  Dispute = 'Dispute',
  Manual = 'Manual',
  Refund = 'Refund',
  StandaloneFee = 'StandaloneFee'
}

export type LoanStatementLineItem = {
  __typename?: 'LoanStatementLineItem';
  /** Description of the statement line item. */
  description: Scalars['String']['output'];
  /** The type of the statement line item. */
  entryType: LineItemEntryType;
  /** Amount before tax in minor currency units. */
  netAmount: Scalars['Long']['output'];
  /** If the transaction was received in a currency other than the settlement currency, how it was converted. */
  originalAmount: LoanFxRateConversion;
  /** Tax amount in minor currency units. */
  taxAmount: Scalars['Long']['output'];
  /** The tax rate applied to the line item, as a rate — 0.1 represents 10% tax. */
  taxRate?: Maybe<Scalars['BigDecimal']['output']>;
  /** Name for the tax being applied. */
  taxType?: Maybe<Scalars['String']['output']>;
  /** Total amount including tax in minor currency units. */
  totalAmount: Scalars['Long']['output'];
};

export type LoanStatementNode = {
  __typename?: 'LoanStatementNode';
  /** Total amount due on the statement excluding late fees, in minor currency units. */
  billedAmount: Scalars['Long']['output'];
  /** Address of the company issuing the loan statement. */
  billerAddress: BusinessAddress;
  /** Legal name of the company issuing the loan statement. */
  billerName: Scalars['String']['output'];
  /** Phone number for the company issuing the loan statement. */
  billerPhoneNumber: Scalars['String']['output'];
  /** Support email address for the company issuing the loan statement. */
  billerSupportEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Tax id of the company issuing the loan statement. */
  billerTaxId: Scalars['String']['output'];
  /** When the loan statement was issued. */
  billingDate: Scalars['LocalDate']['output'];
  /** The merchant borrowing against the loan. */
  borrowerMerchant?: Maybe<MerchantNode>;
  /** When the statement was created, in the loan's timezone. */
  createdAt: Scalars['OffsetDateTime']['output'];
  /** The customer in scope for the loan, if any. */
  customer?: Maybe<MerchantCustomerNode>;
  /** Business address associated with the organisational customer, if any. */
  customerAddress?: Maybe<BusinessAddress>;
  /** Metadata associated with the organisational customer, if any. */
  customerMetadata?: Maybe<Scalars['String']['output']>;
  /** The name of the customer in scope for the loan, if any. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** The tax id for organisational customers, if any. */
  customerTaxId?: Maybe<Scalars['String']['output']>;
  /** When repayment is due for this statement. */
  dueDate: Scalars['LocalDate']['output'];
  /** The individual lines making up this statement. Only loaded when explicitly selected — a statement can carry a large number of entries. */
  entries?: Maybe<Array<LoanStatementEntryNode>>;
  /** Total fees included in this statement excluding late fees, in minor currency units. */
  feeAmount: Scalars['Long']['output'];
  /** Sum of all insurance entries, before tax, in minor currency units. */
  insuranceAmount: Scalars['Long']['output'];
  /** Amount owed due to late fees, in minor currency units. */
  lateFeeAmount: Scalars['Long']['output'];
  /** The late fee line item, if a late fee has been charged. */
  lateFeeLineItem?: Maybe<LoanStatementLineItem>;
  /** The loan this statement was issued against. */
  loan?: Maybe<LoanNode>;
  /** Account name associated with the loan. */
  loanAccountName: Scalars['String']['output'];
  /** Metadata associated with the loan, if any. */
  loanMetadata?: Maybe<Scalars['String']['output']>;
  loanProductType?: Maybe<LoanProductType>;
  /** System unique identifier for the loan statement. */
  loanStatementId: Scalars['String']['output'];
  /** Timezone of the loan, used to determine statement time windows and for reporting. */
  loanTimeZone: Scalars['String']['output'];
  /** Sum of all non-insurance entries, before tax, in minor currency units. */
  netAmount: Scalars['Long']['output'];
  /** Total amount remaining to be paid against this statement including late fees, in minor currency units. */
  outstandingAmount: Scalars['Long']['output'];
  /** How much has already been paid towards this statement, in minor currency units. */
  paidAmount: Scalars['Long']['output'];
  /** Events related to the payment of this statement. */
  paymentEvents: Array<LoanStatementPaymentEvent>;
  /** A reference provided by the merchant to identify the customer. */
  referenceCustomerId?: Maybe<Scalars['String']['output']>;
  /** A reference provided by the applicant to identify the loan. */
  referenceLoanId?: Maybe<Scalars['String']['output']>;
  /** Customer-visible identifier for the loan statement. */
  referenceStatementId: Scalars['String']['output'];
  /** The currency used in this statement. */
  settlementCurrency: Currency;
  /** The end of the last day of loan entries included in the statement. */
  statementEndAt: Scalars['OffsetDateTime']['output'];
  /** The last day of loan entries included in the statement. */
  statementEndDate: Scalars['LocalDate']['output'];
  /** The start of the first day of loan entries included in the statement. */
  statementStartAt: Scalars['OffsetDateTime']['output'];
  /** The first day of loan entries included in the statement. */
  statementStartDate: Scalars['LocalDate']['output'];
  /** Status of the repayment of this loan statement. */
  status: LoanStatementStatus;
  /** Sum of tax amount over all entries, in minor currency units. */
  taxAmount: Scalars['Long']['output'];
  /** Total number of entries in the loan statement. */
  totalEntryCount: Scalars['Long']['output'];
};

export type LoanStatementPaymentEvent = AutoPaymentFromCreditBalance | CreditAppliedToNewStatement | ManualPaymentMarked;

export type LoanStatementSearchConnection = {
  __typename?: 'LoanStatementSearchConnection';
  edges: Array<LoanStatementSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type LoanStatementSearchEdge = {
  __typename?: 'LoanStatementSearchEdge';
  cursor: Scalars['String']['output'];
  node: LoanStatementNode;
};

export enum LoanStatementSearchOrderField {
  /** Order by when the statement was created. */
  CreatedAt = 'CreatedAt',
  /** Order by when repayment is due for the statement. */
  DueOn = 'DueOn',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type LoanStatementSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: LoanStatementSearchOrderField;
};

export enum LoanStatementStatus {
  Cancelled = 'Cancelled',
  Defaulted = 'Defaulted',
  Draft = 'Draft',
  Due = 'Due',
  Outstanding = 'Outstanding',
  Overdue = 'Overdue',
  Paid = 'Paid'
}

export type LoanStatementSupplierDetails = {
  __typename?: 'LoanStatementSupplierDetails';
  /** IATA 8-digit numeric code for the agency. */
  iataNumber?: Maybe<Scalars['String']['output']>;
  /** Business name of the supplier the transaction is associated with. */
  name?: Maybe<Scalars['String']['output']>;
};

export enum LoanStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type LocalDateFilterInput = {
  /** Value equals the given date. Use ISO-8601 format (e.g. '2024-09-03'). */
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Value is greater than the given date. */
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Value is greater than or equal to the given date. */
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Value is less than the given date. */
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  /** Value is less than or equal to the given date. */
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type LogicError = {
  __typename?: 'LogicError';
  message: Scalars['String']['output'];
};

/** A payment recorded manually against the statement. */
export type ManualPaymentMarked = {
  __typename?: 'ManualPaymentMarked';
  amount: Scalars['Long']['output'];
  timestamp: Scalars['Instant']['output'];
  user: Scalars['String']['output'];
};

export type MerchantBillingDetails = {
  __typename?: 'MerchantBillingDetails';
  billingAddress: BusinessAddress;
  billingNotificationEmails: Array<Scalars['String']['output']>;
  billingNotificationsEnabled: Scalars['Boolean']['output'];
  billingPaymentSourceId?: Maybe<Scalars['String']['output']>;
};

export type MerchantCustomerNode = {
  __typename?: 'MerchantCustomerNode';
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Email address of the customer. */
  customerEmailAddress: Scalars['String']['output'];
  /** System unique identifier for the customer. */
  customerId: Scalars['String']['output'];
  /** Full name of the customer. */
  customerName: Scalars['String']['output'];
  /** Phone number of the customer. */
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  merchant?: Maybe<MerchantNode>;
  /** A reference provided by the merchant to identify this customer. If provided, must be unique for the given merchant. */
  referenceCustomerId?: Maybe<Scalars['String']['output']>;
};

export type MerchantCustomerSearchConnection = {
  __typename?: 'MerchantCustomerSearchConnection';
  edges: Array<MerchantCustomerSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type MerchantCustomerSearchEdge = {
  __typename?: 'MerchantCustomerSearchEdge';
  cursor: Scalars['String']['output'];
  node: MerchantCustomerNode;
};

export enum MerchantCustomerSearchOrderField {
  /** Order by when the customer was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type MerchantCustomerSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: MerchantCustomerSearchOrderField;
};

export enum MerchantDashboardStatus {
  Active = 'Active',
  Pending = 'Pending',
  Suspended = 'Suspended'
}

export type MerchantDetails = {
  __typename?: 'MerchantDetails';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<IsoCountry>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  iataNumber?: Maybe<Scalars['String']['output']>;
  merchantCategoryCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type MerchantNode = {
  __typename?: 'MerchantNode';
  bankAccounts?: Maybe<Array<BankAccountNode>>;
  billingDetails?: Maybe<MerchantBillingDetails>;
  businessProfile: BusinessProfile;
  createdAt: Scalars['OffsetDateTime']['output'];
  /** System unique identifier for the merchant. */
  merchantId: Scalars['String']['output'];
  merchantType: MerchantType;
  payoutDetails?: Maybe<MerchantPayoutDetails>;
  /** Unique URL used for dashboards. Must be 4-255 characters, lowercase, alphanumeric without any special characters such as `! @ # & ( ) – [ ] : ; ‘, ? /`. */
  readableIdentifier: Scalars['String']['output'];
  /** A unique string for this merchant, such as your primary key. */
  referenceMerchantId?: Maybe<Scalars['String']['output']>;
  verificationResult?: Maybe<VerificationResult>;
};

export type MerchantPayoutDetails = {
  __typename?: 'MerchantPayoutDetails';
  automatedDisbursementsEnabled: Scalars['Boolean']['output'];
  automatedPayoutsEnabled: Scalars['Boolean']['output'];
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  payoutDefaultStatementDescriptor?: Maybe<Scalars['String']['output']>;
  payoutDelayDays: Scalars['Int']['output'];
  payoutExpediteNonBusinessDays: Scalars['Boolean']['output'];
  payoutRemitterName?: Maybe<Scalars['String']['output']>;
  payoutSchedule: Scalars['String']['output'];
  payoutSettings: PayoutSettings;
  payoutStatus: MerchantPayoutStatus;
};

export enum MerchantPayoutStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type MerchantSearchConnection = {
  __typename?: 'MerchantSearchConnection';
  edges: Array<MerchantSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches. */
  totalCount: Scalars['Long']['output'];
};

export type MerchantSearchEdge = {
  __typename?: 'MerchantSearchEdge';
  cursor: Scalars['String']['output'];
  node: MerchantNode;
};

export enum MerchantSearchOrderField {
  /** Order by when the merchant was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type MerchantSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: MerchantSearchOrderField;
};

export enum MerchantType {
  ServiceProvider = 'ServiceProvider',
  Standard = 'Standard'
}

export type MetadataFieldConstraint = DaysRequiredWithin | NotRequired;

export enum MetadataFieldFormat {
  Alphabetic = 'Alphabetic',
  Alphanumeric = 'Alphanumeric',
  IsoDate = 'IsoDate',
  Numeric = 'Numeric'
}

export type MetadataFieldValidator = {
  __typename?: 'MetadataFieldValidator';
  format: MetadataFieldFormat;
  maxLength: Scalars['Int']['output'];
  minLength: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  statementConstraint: MetadataFieldConstraint;
  transactionConstraint: MetadataFieldConstraint;
};

export type MetadataFieldValidatorEntry = {
  __typename?: 'MetadataFieldValidatorEntry';
  /** Dot-separated path to the metadata field this validator applies to. */
  path: Scalars['String']['output'];
  /** The individual path steps making up `path`. */
  steps: Array<Scalars['String']['output']>;
  validator: MetadataFieldValidator;
};

export type MetadataTemplate = {
  __typename?: 'MetadataTemplate';
  validations: Array<MetadataFieldValidatorEntry>;
};

export type MetadataValidationOutcome = {
  __typename?: 'MetadataValidationOutcome';
  invalid?: Maybe<Array<KvStringInvalidField>>;
};

/** Issued once a month on the given day of the month. */
export type Monthly = {
  __typename?: 'Monthly';
  issueDayOfMonth: Scalars['Int']['output'];
};

export type NoAction = {
  __typename?: 'NoAction';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type None = {
  __typename?: 'None';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** The field is never required. */
export type NotRequired = {
  __typename?: 'NotRequired';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type NotSupported = {
  __typename?: 'NotSupported';
  info: OptionString;
  version: OptionString;
};

export type NzBankAccountIdentifier = {
  __typename?: 'NzBankAccountIdentifier';
  accountNumber: Scalars['String']['output'];
};

export enum OnboardingErrorCode {
  CompanyTypeMissing = 'CompanyTypeMissing',
  DocumentAddressMismatch = 'DocumentAddressMismatch',
  DocumentAddressMissing = 'DocumentAddressMissing',
  DocumentBackNotNeeded = 'DocumentBackNotNeeded',
  DocumentCountryNotSupported = 'DocumentCountryNotSupported',
  DocumentDobMismatch = 'DocumentDobMismatch',
  DocumentDuplicateType = 'DocumentDuplicateType',
  DocumentExpired = 'DocumentExpired',
  DocumentFailedCopy = 'DocumentFailedCopy',
  DocumentFailedGreyscale = 'DocumentFailedGreyscale',
  DocumentFailedOther = 'DocumentFailedOther',
  DocumentFraudulent = 'DocumentFraudulent',
  DocumentIdNumberMismatch = 'DocumentIdNumberMismatch',
  DocumentIdNumberMissing = 'DocumentIdNumberMissing',
  DocumentIncomplete = 'DocumentIncomplete',
  DocumentInvalid = 'DocumentInvalid',
  DocumentIssueOrExpiryDateMissing = 'DocumentIssueOrExpiryDateMissing',
  DocumentMissingBack = 'DocumentMissingBack',
  DocumentMissingFront = 'DocumentMissingFront',
  DocumentNameMismatch = 'DocumentNameMismatch',
  DocumentNameMissing = 'DocumentNameMissing',
  DocumentNationalityMismatch = 'DocumentNationalityMismatch',
  DocumentNotReadable = 'DocumentNotReadable',
  DocumentNotSigned = 'DocumentNotSigned',
  DocumentNotUploaded = 'DocumentNotUploaded',
  DocumentPhotoMismatch = 'DocumentPhotoMismatch',
  DocumentSameFrontBack = 'DocumentSameFrontBack',
  DocumentTooLarge = 'DocumentTooLarge',
  DocumentTypeNotSupported = 'DocumentTypeNotSupported',
  DriverLicenceDocumentNumberMissing = 'DriverLicenceDocumentNumberMissing',
  DriverLicenceMissing = 'DriverLicenceMissing',
  DriverLicenceStateMissing = 'DriverLicenceStateMissing',
  DriverLicenceStateNotNeeded = 'DriverLicenceStateNotNeeded',
  DriverLicenceVersionNumberMissing = 'DriverLicenceVersionNumberMissing',
  FailedAddressMatch = 'FailedAddressMatch',
  FailedBusinessIecNumber = 'FailedBusinessIecNumber',
  FailedDocumentMatch = 'FailedDocumentMatch',
  FailedIdNumberMatch = 'FailedIdNumberMatch',
  FailedKeyedIdentity = 'FailedKeyedIdentity',
  FailedKeyedMatch = 'FailedKeyedMatch',
  FailedNameMatch = 'FailedNameMatch',
  FailedOther = 'FailedOther',
  FailedTaxIdMatch = 'FailedTaxIdMatch',
  FailedTaxIdNotIssued = 'FailedTaxIdNotIssued',
  IdMissing = 'IdMissing',
  IndustryMissing = 'IndustryMissing',
  InvalidAddress = 'InvalidAddress',
  InvalidBrandName = 'InvalidBrandName',
  InvalidBusinessAddress = 'InvalidBusinessAddress',
  InvalidBusinessContactFirstName = 'InvalidBusinessContactFirstName',
  InvalidBusinessContactLastName = 'InvalidBusinessContactLastName',
  InvalidBusinessCountry = 'InvalidBusinessCountry',
  InvalidBusinessName = 'InvalidBusinessName',
  InvalidCardStatementName = 'InvalidCardStatementName',
  InvalidCity = 'InvalidCity',
  InvalidContactEmail = 'InvalidContactEmail',
  InvalidFirstName = 'InvalidFirstName',
  InvalidLastName = 'InvalidLastName',
  InvalidNzDriverLicenceVersion = 'InvalidNZDriverLicenceVersion',
  InvalidPersonAddress = 'InvalidPersonAddress',
  InvalidPersonAge = 'InvalidPersonAge',
  InvalidPhoneNum = 'InvalidPhoneNum',
  InvalidPostalCode = 'InvalidPostalCode',
  InvalidSlug = 'InvalidSlug',
  InvalidSmsSenderName = 'InvalidSmsSenderName',
  InvalidState = 'InvalidState',
  InvalidSupportEmail = 'InvalidSupportEmail',
  InvalidSupportSite = 'InvalidSupportSite',
  InvalidTaxId = 'InvalidTaxId',
  InvalidTimeZone = 'InvalidTimeZone',
  InvalidTradeLicence = 'InvalidTradeLicence',
  InvalidTradeType = 'InvalidTradeType',
  InvalidWebsite = 'InvalidWebsite',
  MerchantAlreadyVerified = 'MerchantAlreadyVerified',
  MerchantGatewayAccountMissing = 'MerchantGatewayAccountMissing',
  MerchantIsNotActive = 'MerchantIsNotActive',
  MerchantStateInvalid = 'MerchantStateInvalid',
  MissingBankAccount = 'MissingBankAccount',
  MissingDirectors = 'MissingDirectors',
  MissingExecutives = 'MissingExecutives',
  MissingGatewayPersonAccount = 'MissingGatewayPersonAccount',
  MissingIndividual = 'MissingIndividual',
  MissingOwnerOrExecutive = 'MissingOwnerOrExecutive',
  MissingOwners = 'MissingOwners',
  MultipleIdsFound = 'MultipleIdsFound',
  PartnershipAgreementDocMissing = 'PartnershipAgreementDocMissing',
  PassportExpired = 'PassportExpired',
  PassportMissing = 'PassportMissing',
  PersonInformationMissing = 'PersonInformationMissing',
  RequiresAdditionalMemorandumOfAssociations = 'RequiresAdditionalMemorandumOfAssociations',
  TrustDeedDocMissing = 'TrustDeedDocMissing',
  UnknownError = 'UnknownError',
  UnsupportedIdType = 'UnsupportedIdType'
}

export type OptionBoolean = None | SomeBoolean;

export type OptionString = None | SomeString;

export type OrderNode = {
  __typename?: 'OrderNode';
  /** The un-surcharged order amount. */
  amount: CurrencyAmount;
  /** Billing address for the order. */
  billing?: Maybe<Billing>;
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Optional email address of the customer. */
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Optional name of the customer. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Optional phone number of the customer. */
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** A free text description of the order. */
  description?: Maybe<Scalars['String']['output']>;
  /** Discount applied to order _in minor currency units_. */
  discountAmount?: Maybe<Scalars['Long']['output']>;
  /** A list of line items included in the order. */
  items: Array<Item>;
  merchant?: Maybe<MerchantNode>;
  /** Merchant specific additional data associated with this order. */
  metadata?: Maybe<Scalars['String']['output']>;
  /** System unique identifier for the order. */
  orderId: Scalars['String']['output'];
  orderType: OrderType;
  /** A reference provided by the merchant to identify this order, such as an order number. */
  referenceOrderId: Scalars['String']['output'];
  /** How payments for this order settle. */
  settlementConfiguration: SettlementConfiguration;
  /** Shipping address for the order. */
  shipping?: Maybe<Shipping>;
  status: OrderStatus;
  /** The amount _in minor currency units_ that was surcharged to the customer. */
  surchargeAmount: Scalars['Long']['output'];
  /** When the order was last updated. */
  updatedAt?: Maybe<Scalars['OffsetDateTime']['output']>;
};

export type OrderSearchConnection = {
  __typename?: 'OrderSearchConnection';
  edges: Array<OrderSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type OrderSearchEdge = {
  __typename?: 'OrderSearchEdge';
  cursor: Scalars['String']['output'];
  node: OrderNode;
};

export enum OrderSearchOrderField {
  /** Order by when the order was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type OrderSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: OrderSearchOrderField;
};

export enum OrderStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Created = 'Created',
  Fulfilled = 'Fulfilled',
  Paid = 'Paid',
  Returned = 'Returned'
}

export enum OrderType {
  Invoice = 'Invoice',
  Online = 'Online',
  PayByLink = 'PayByLink'
}

export type Outcome3ds = AuthenticationUnavailable | FailedChallenge | FailedFrictionless | FailedTokenized | FlowNotAttempted | IncompleteChallenge | LogicError | NotSupported | PassedChallenge | PassedFrictionless | PassedTokenized | ResultNotAvailableError;

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ParentAcquiringTransactionId = {
  __typename?: 'ParentAcquiringTransactionId';
  transactionId: Scalars['String']['output'];
};

export type ParentIssuingTransactionId = {
  __typename?: 'ParentIssuingTransactionId';
  issuerTransactionId: Scalars['String']['output'];
};

export type ParentTransactionIdSubNode = ParentAcquiringTransactionId | ParentIssuingTransactionId;

export type PassedChallenge = {
  __typename?: 'PassedChallenge';
  acsTransID: OptionString;
  authenticationValue: OptionString;
  directoryServerTransactionId: OptionString;
  eci: OptionString;
  info: OptionString;
  liabilityShifted: OptionBoolean;
  threeDSServerTransID: OptionString;
  version: OptionString;
  xid: OptionString;
};

export type PassedFrictionless = {
  __typename?: 'PassedFrictionless';
  acsTransID: OptionString;
  authenticationValue: OptionString;
  directoryServerTransactionId: OptionString;
  eci: OptionString;
  info: OptionString;
  liabilityShifted: OptionBoolean;
  threeDSServerTransID: OptionString;
  version: OptionString;
  xid: OptionString;
};

export type PassedTokenized = {
  __typename?: 'PassedTokenized';
  eci: OptionString;
  liabilityShifted: OptionBoolean;
  transStatus: OptionString;
};

export type PayToFailure = {
  __typename?: 'PayToFailure';
  code: PayToFailureCode;
  detail: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum PayToFailureCode {
  Other = 'Other'
}

export type PayToPaymentMethod = {
  __typename?: 'PayToPaymentMethod';
  accountHint: Scalars['String']['output'];
  paymentFailure?: Maybe<PayToFailure>;
  paymentMethodType: PaymentMethodType;
  paymentStatus: PaymentStatus;
};

export enum PayType {
  PayInFull = 'PayInFull',
  PayPlan = 'PayPlan'
}

export enum PaymentChannel {
  DirectEntry = 'DirectEntry',
  Npp = 'Npp'
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  bin: Scalars['String']['output'];
  cardBrand: CardBrand;
  cardCreator?: Maybe<Scalars['String']['output']>;
  cardHolderName: Scalars['String']['output'];
  country: IsoCountry;
  digitalCreditCardId?: Maybe<Scalars['String']['output']>;
  digitalCreditCardIdSynonyms: Array<DigitalCreditCardIdSynonymDto>;
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
  loanId?: Maybe<Scalars['String']['output']>;
  pan?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethodSubNode = CardPaymentMethod | DirectDebitPaymentMethod | PayToPaymentMethod;

export enum PaymentMethodType {
  Card = 'Card',
  DirectDebit = 'DirectDebit',
  PayTo = 'PayTo'
}

export enum PaymentStatus {
  Created = 'Created',
  Failed = 'Failed',
  Settled = 'Settled'
}

export type PayoutNode = {
  __typename?: 'PayoutNode';
  /** The amount credited towards the payout. */
  amount: CurrencyAmount;
  /** The bank account the payout was sent to. */
  bankAccount?: Maybe<BankAccountNode>;
  /**
   *
   * The closing balance of the merchant account after payout has settled **in minor currency units**.
   * Will usually be `0` but will be negative if the merchant account has a negative balance.
   *
   */
  closingBalance: Scalars['Long']['output'];
  /** When the payout was created. */
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  merchant?: Maybe<MerchantNode>;
  /**
   *
   * The opening balance of the merchant account before the payout was settled **in minor currency units**.
   * Will usually be `0` but will be negative if the merchant account has a negative balance from a previous payout.
   *
   */
  openingBalance: Scalars['Long']['output'];
  /** The rail the payout was disbursed over. */
  paymentChannel?: Maybe<PaymentChannel>;
  /** System unique identifier for the payout. */
  payoutId: Scalars['String']['output'];
  /** A unique reference for the payout shown to the merchant. */
  referencePayoutId?: Maybe<Scalars['String']['output']>;
  /** The date the payout settles with the merchant. */
  settlementDate?: Maybe<Scalars['LocalDate']['output']>;
  /** Information about the payout that will appear on the customer's bank statement. */
  statementDescriptor?: Maybe<Scalars['String']['output']>;
  /** Status of the invoice. */
  status: PayoutStatus;
  /** The amount paid out or the closing balance if the merchant account has a negative balance **in minor currency units**. */
  totalAmount: Scalars['Long']['output'];
};

export type PayoutSearchConnection = {
  __typename?: 'PayoutSearchConnection';
  edges: Array<PayoutSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type PayoutSearchEdge = {
  __typename?: 'PayoutSearchEdge';
  cursor: Scalars['String']['output'];
  node: PayoutNode;
};

export enum PayoutSearchOrderField {
  /** Order by the amount credited towards the payout. */
  Amount = 'Amount',
  /** Order by the date the payout settles with the merchant. */
  AvailableOn = 'AvailableOn',
  /** Order by when the payout was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score',
  /** Order by the status of the payout. */
  Status = 'Status'
}

export type PayoutSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: PayoutSearchOrderField;
};

export type PayoutSettings = {
  __typename?: 'PayoutSettings';
  notificationEmails: Array<Scalars['String']['output']>;
  notificationsEnabled: Scalars['Boolean']['output'];
};

export enum PayoutStatus {
  Canceled = 'Canceled',
  Created = 'Created',
  Failed = 'Failed',
  InTransit = 'InTransit',
  Paid = 'Paid',
  Pending = 'Pending',
  Reversed = 'Reversed',
  Suspended = 'Suspended'
}

export type PurchaseDetails = {
  __typename?: 'PurchaseDetails';
  additionalTransactionReferenceId?: Maybe<Scalars['String']['output']>;
  approvalCode?: Maybe<Scalars['String']['output']>;
  auditNumber: Scalars['String']['output'];
  authorisedAmount: Scalars['Long']['output'];
  borrowerCustomerId?: Maybe<Scalars['String']['output']>;
  capturedAmount: Scalars['Long']['output'];
  charge: Charge;
  createdAt: Scalars['Instant']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  disputes: Array<Dispute>;
  expiryAction: DtoExpiryAction;
  merchantId?: Maybe<Scalars['String']['output']>;
  originatingMerchantId?: Maybe<Scalars['String']['output']>;
  pairedTransactionId?: Maybe<Scalars['String']['output']>;
  publicAt?: Maybe<Scalars['Instant']['output']>;
  publishedAt?: Maybe<Scalars['Instant']['output']>;
  referenceTransactionId?: Maybe<Scalars['String']['output']>;
  refundedAmount: Scalars['Long']['output'];
  refunds: Array<Refund>;
  status: DtoIssuerTransactionStatus;
  transactedAt?: Maybe<Scalars['Instant']['output']>;
  transactionMode: TransactionMode;
  updatedAt: Scalars['Instant']['output'];
};

export type PurchaseDetailsSubNode = {
  __typename?: 'PurchaseDetailsSubNode';
  /** The order amount including any surcharge passed on to the customer. */
  amount: CurrencyAmount;
  /** The day this payment will be available for payout to the merchant. */
  availableOn?: Maybe<Scalars['LocalDate']['output']>;
  createdAt: Scalars['OffsetDateTime']['output'];
  /** A free text description of the order. */
  description?: Maybe<Scalars['String']['output']>;
  /** Business name of the merchant the order is associated with. */
  merchantName: Scalars['String']['output'];
  /** Metadata passed in when creating the order. */
  orderMetadata?: Maybe<Scalars['String']['output']>;
  orderType: OrderType;
  /** The day the payment was settled with the merchant. Only set after a successful payout. */
  paidOn?: Maybe<Scalars['LocalDate']['output']>;
  /** The transaction this one is linked to, if any. */
  parentTransactionId?: Maybe<ParentTransactionIdSubNode>;
  payType: PayType;
  /** The corresponding issuer transaction, when this runs as a closed loop transaction. */
  referenceIssuerTransactionId?: Maybe<Scalars['String']['output']>;
  /** A reference provided by the merchant to identify this order, such as an order number. */
  referenceOrderId: Scalars['String']['output'];
  /** A reference provided by the merchant to identify this transaction. */
  referenceTransactionId?: Maybe<Scalars['String']['output']>;
  /** The amount _in minor currency units_ that has been refunded to the customer. */
  refundedAmount: Scalars['Long']['output'];
  status: TransactionStatus;
  /** The amount _in minor currency units_ that was surcharged to the customer. */
  surchargeAmount: Scalars['Long']['output'];
  updatedAt: Scalars['OffsetDateTime']['output'];
};

export type Queries = {
  __typename?: 'Queries';
  /** Perform a full-text search against customers. Keywords are matched against the customer's name, email address, reference id, and phone number. */
  customers?: Maybe<MerchantCustomerSearchConnection>;
  /** Perform a full-text search against digital cards. Keywords are matched against the card holder name, creator and provider identifier. Only cards issued against loans the credentials can read are returned. */
  digitalCards?: Maybe<DigitalCardSearchConnection>;
  /** Perform a full-text search against disputes. Keywords are matched against the dispute's state, reason and disputed amount. */
  disputes?: Maybe<DisputeSearchConnection>;
  /** Perform a full-text search against issuer transactions. Keywords are matched against the issuer transaction system identifier, referenceTransactionId, amount captured, acquiring merchant name, traveller name, supplier name, travel agency invoice number and conferma deployment no. */
  issuerTransactions?: Maybe<IssuerTransactionSearchConnection>;
  /** Perform a full-text search against loan statements. Keywords are matched against the statement's customer-visible reference id. */
  loanStatements?: Maybe<LoanStatementSearchConnection>;
  /** Perform a full-text search against loans. Keywords are matched against the loan's reference id and account name. */
  loans?: Maybe<LoanSearchConnection>;
  /** Perform a full-text search against merchants. Only available with marketplace or admin level credentials. Keywords are matched against the merchant's business name, brand name, readable identifier or system identifier. */
  merchants?: Maybe<MerchantSearchConnection>;
  /** Perform a full-text search against orders. Keywords are matched against the order description, reference id, amount, brand name, and sku and description from the individual items. */
  orders?: Maybe<OrderSearchConnection>;
  /** Perform a full-text search against payouts. Keywords are matched against the payout system identifier, statement descriptor and amount. */
  payouts?: Maybe<PayoutSearchConnection>;
  /** Perform a full-text search against refunds. Keywords are matched against the refund system identifier and amount. */
  refunds?: Maybe<RefundSearchConnection>;
  settlementEntries?: Maybe<SettlementEntryConnection>;
  /** Perform a full-text search against transactions. Keywords are matched against the transaction system identifier and amount. */
  transactions?: Maybe<TransactionSearchConnection>;
};


export type QueriesCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  customerEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<MerchantCustomerSearchOrderInput>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueriesDigitalCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cardBrand?: InputMaybe<CardBrand>;
  cardHolderName?: InputMaybe<Scalars['String']['input']>;
  cardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<InstantFilterInput>;
  creator?: InputMaybe<Scalars['String']['input']>;
  customerDelegateUserId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  last4?: InputMaybe<Scalars['String']['input']>;
  loanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<DigitalCardSearchOrderInput>;
  providerIdentifier?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<DigitalCardStatus>>;
};


export type QueriesDisputesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Currency>;
  disputeAmount?: InputMaybe<Scalars['Long']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<DisputeSearchOrderInput>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  outcome?: InputMaybe<DisputeOutcome>;
  query?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesIssuerTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  borrowerCustomerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  borrowerMarketplaceId?: InputMaybe<Scalars['String']['input']>;
  borrowerMerchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  capturedAmount?: InputMaybe<AmountFilterInput>;
  cardBrand?: InputMaybe<CardBrand>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  cardLast4?: InputMaybe<Scalars['String']['input']>;
  chargeStatus?: InputMaybe<Array<ChargeStatusInput>>;
  confermaDeploymentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  issuerNetworkType?: InputMaybe<IssuerNetworkType>;
  issuerTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  loanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Array<IssuerTransactionSearchOrderInput>>;
  publicAt?: InputMaybe<InstantFilterInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  referenceTransactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<DtoIssuerTransactionStatus>>;
  supplierInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  transactedAt?: InputMaybe<InstantFilterInput>;
  travelAgencyInvoiceNumber?: InputMaybe<Scalars['String']['input']>;
  travellerName?: InputMaybe<Scalars['String']['input']>;
};


export type QueriesLoanStatementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Currency>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dueOn?: InputMaybe<LocalDateFilterInput>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  loanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  loanStatementIds?: InputMaybe<Array<Scalars['String']['input']>>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<LoanStatementSearchOrderInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  referenceStatementId?: InputMaybe<Scalars['String']['input']>;
};


export type QueriesLoansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Currency>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  loanAccountName?: InputMaybe<Scalars['String']['input']>;
  loanIds?: InputMaybe<Array<Scalars['String']['input']>>;
  loanProductTypes?: InputMaybe<Array<LoanProductType>>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<LoanSearchOrderInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  referenceLoanId?: InputMaybe<Scalars['String']['input']>;
};


export type QueriesMerchantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MerchantSearchOrderInput>;
  payoutStatus?: InputMaybe<MerchantPayoutStatus>;
  query?: InputMaybe<Scalars['String']['input']>;
  referenceMerchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<MerchantDashboardStatus>;
};


export type QueriesOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Currency>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<OrderSearchOrderInput>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderType?: InputMaybe<Array<OrderType>>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<OrderStatus>>;
};


export type QueriesPayoutsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Currency>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<PayoutSearchOrderInput>;
  payoutIds?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<LocalDateFilterInput>;
  status?: InputMaybe<Array<PayoutStatus>>;
};


export type QueriesRefundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Currency>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<RefundSearchOrderInput>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  refundContextualId?: InputMaybe<Scalars['String']['input']>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesSettlementEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Currency>;
  entryTypes?: InputMaybe<Array<EntryType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<SettlementEntryOrderInput>>;
  payoutId?: InputMaybe<Scalars['String']['input']>;
  settlementDate?: InputMaybe<LocalDateFilterInput>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueriesTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  availableOn?: InputMaybe<LocalDateFilterInput>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  currency?: InputMaybe<Currency>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enterpriseId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketplaceId?: InputMaybe<Scalars['String']['input']>;
  merchantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<TransactionSearchOrderInput>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  payType?: InputMaybe<PayType>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<TransactionStatus>>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RealtimeSettlementLoanSpecification = {
  __typename?: 'RealtimeSettlementLoanSpecification';
  /** The settings for when to use real-time settlement for new payments. */
  setting: RealtimeSettlementSetting;
  /** The fee rate charged for payments that facilitate the real-time settlement service. */
  variableFee: Scalars['BigDecimal']['output'];
};

export enum RealtimeSettlementSetting {
  /** All payments use real-time settlement, if available, otherwise standard settlement will be used. */
  AutomaticPreferred = 'AutomaticPreferred',
  /** All payments use real-time settlement, if available, otherwise the payment will fail. */
  AutomaticRequired = 'AutomaticRequired',
  /** Standard settlement will be used unless explicitly configured on the order. */
  Manual = 'Manual'
}

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['Long']['output'];
  autoPublishAt: Scalars['Instant']['output'];
  createdAt: Scalars['Instant']['output'];
  currency: Scalars['String']['output'];
  customerStatementId?: Maybe<Scalars['String']['output']>;
  customerStatementIssueDate?: Maybe<Scalars['LocalDate']['output']>;
  customerStatementReferenceId?: Maybe<Scalars['String']['output']>;
  fxRateConversion: FxRateConversion;
  metadata: Scalars['String']['output'];
  metadataValidationOutcome?: Maybe<MetadataValidationOutcome>;
  netAmount: Scalars['Long']['output'];
  publicAt?: Maybe<Scalars['Instant']['output']>;
  publishedAt?: Maybe<Scalars['Instant']['output']>;
  referenceRefundId?: Maybe<Scalars['String']['output']>;
  refundId: Scalars['String']['output'];
  status: RefundStatus;
  taxAmount?: Maybe<Scalars['Long']['output']>;
  taxRate?: Maybe<Scalars['BigDecimal']['output']>;
  taxType?: Maybe<Scalars['String']['output']>;
  travelDetails: TravelDetails;
  updatedAt: Scalars['Instant']['output'];
};

export type RefundNode = {
  __typename?: 'RefundNode';
  /** When the refund was created. */
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  merchant?: Maybe<MerchantNode>;
  /** The payout this refund was included in. */
  payout?: Maybe<PayoutNode>;
  /** The refunded amount. */
  refundAmount: IsoCurrencyAmount;
  /** System unique identifier for the refund. */
  refundId: Scalars['String']['output'];
  /** Who issued the refund. */
  refundIssuedBy?: Maybe<Scalars['String']['output']>;
  /** When the refund was issued, if it has been. Distinct from `createdAt`, which is when the record was created. */
  refundedAt?: Maybe<Scalars['Instant']['output']>;
  transaction?: Maybe<TransactionNode>;
};

export type RefundSearchConnection = {
  __typename?: 'RefundSearchConnection';
  edges: Array<RefundSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type RefundSearchEdge = {
  __typename?: 'RefundSearchEdge';
  cursor: Scalars['String']['output'];
  node: RefundNode;
};

export enum RefundSearchOrderField {
  /** Order by when the refund was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score'
}

export type RefundSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: RefundSearchOrderField;
};

export enum RefundStatus {
  PublishedToStatement = 'PublishedToStatement',
  Refunded = 'Refunded'
}

export type RefundSubNode = {
  __typename?: 'RefundSubNode';
  /** When the refund was created. */
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The payout this refund was included in. */
  payout?: Maybe<PayoutNode>;
  /** The refunded amount. */
  refundAmount: IsoCurrencyAmount;
  /** System unique identifier for the refund. */
  refundId: Scalars['String']['output'];
};

export enum RequiredStatus {
  Lapsed = 'Lapsed',
  NotRequired = 'NotRequired',
  NotSatisfied = 'NotSatisfied'
}

export type ResultNotAvailableError = {
  __typename?: 'ResultNotAvailableError';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceFees = {
  __typename?: 'ServiceFees';
  feeSummary: Scalars['String']['output'];
  fixedAmount: Scalars['Long']['output'];
  taxAmount: Scalars['Long']['output'];
  totalAmount: Scalars['Long']['output'];
  variableAmount: Scalars['Long']['output'];
  variableFeePercentage: Scalars['BigDecimal']['output'];
};

export enum SettlementConfiguration {
  Default = 'Default',
  RealtimePreferred = 'RealtimePreferred',
  RealtimeRequired = 'RealtimeRequired',
  Standard = 'Standard'
}

export type SettlementEntryConnection = {
  __typename?: 'SettlementEntryConnection';
  edges: Array<SettlementEntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Long']['output'];
};

export type SettlementEntryEdge = {
  __typename?: 'SettlementEntryEdge';
  cursor: Scalars['String']['output'];
  node: SettlementEntryNode;
};

export type SettlementEntryNode = {
  __typename?: 'SettlementEntryNode';
  /** The settlement amount. May be positive (a credit) or negative (a debit). */
  amount: CurrencyAmount;
  /** When the settlement entry was created. */
  createdAt?: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Description of settlement entry. */
  entryDescription?: Maybe<Scalars['String']['output']>;
  /** Type of settlement entry. */
  entryType: EntryType;
  merchant?: Maybe<MerchantNode>;
  order?: Maybe<OrderNode>;
  payout?: Maybe<PayoutNode>;
  /** The date this entry settles with the merchant. */
  settlementDate?: Maybe<Scalars['LocalDate']['output']>;
  transaction?: Maybe<TransactionNode>;
};

export enum SettlementEntryOrderField {
  CreatedAt = 'CreatedAt',
  SettlementDate = 'SettlementDate'
}

export type SettlementEntryOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: SettlementEntryOrderField;
};

export type SgBankAccountIdentifier = {
  __typename?: 'SgBankAccountIdentifier';
  accountNumber: Scalars['String']['output'];
};

export type Shipping = {
  __typename?: 'Shipping';
  address: Address;
  amount?: Maybe<Scalars['Long']['output']>;
  carrier?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};

export type SomeBoolean = {
  __typename?: 'SomeBoolean';
  value: Scalars['Boolean']['output'];
};

export type SomeString = {
  __typename?: 'SomeString';
  value: Scalars['String']['output'];
};

export type StatementFrequency = Daily | Fortnightly | Monthly | Weekly;

export type TradingAccountLoanSpecification = {
  __typename?: 'TradingAccountLoanSpecification';
  /** The organisational customer that owns the trade account. */
  customer?: Maybe<MerchantCustomerNode>;
  /** Customer fees associated with this loan. */
  customerFees: LoanCustomerFees;
  /** Number of days between loan statement issue and due dates. */
  graceDays: Scalars['Int']['output'];
  /** The industry group this loan is restricted to, if any. */
  industryGroup?: Maybe<IndustryGroup>;
  metadataTemplate: MetadataTemplate;
  /** How often a customer loan statement is issued. */
  statementFrequency: StatementFrequency;
  /** The brands of card that may be issued against this loan. */
  supportedIssuerBrands: Array<IssuerCardBrand>;
};

export enum TransactionEventType {
  PaymentAccepted = 'PaymentAccepted',
  PaymentAuthorised = 'PaymentAuthorised',
  PaymentCancelled = 'PaymentCancelled',
  PaymentDisputeLost = 'PaymentDisputeLost',
  PaymentDisputeWon = 'PaymentDisputeWon',
  PaymentDisputed = 'PaymentDisputed',
  PaymentFailed = 'PaymentFailed',
  PaymentIncomplete = 'PaymentIncomplete',
  PaymentRefunded = 'PaymentRefunded',
  PaymentSucceed = 'PaymentSucceed',
  PaymentTransferred = 'PaymentTransferred'
}

export enum TransactionMode {
  ClosedLoop = 'ClosedLoop',
  OpenLoop = 'OpenLoop'
}

export type TransactionNode = {
  __typename?: 'TransactionNode';
  customer?: Maybe<MerchantCustomerNode>;
  customerDetails?: Maybe<CustomerDetailsSubNode>;
  disputes: Array<DisputeSubNode>;
  merchant: MerchantNode;
  order: OrderNode;
  paymentMethod?: Maybe<PaymentMethodSubNode>;
  payout?: Maybe<PayoutNode>;
  purchaseDetails: PurchaseDetailsSubNode;
  refunds: Array<RefundSubNode>;
  serviceFees?: Maybe<ServiceFees>;
  /** The transaction's event journal, oldest first. */
  timelines: Array<TransactionTimeLineSubNode>;
  /** System unique identifier for the transaction representing this payment. */
  transactionId: Scalars['String']['output'];
  /** Funds transferred out of this transaction to other sub-merchants, and the journal of those transfers. Absent unless at least one transfer has been made. */
  transfers?: Maybe<TransfersSubNode>;
};

export type TransactionSearchConnection = {
  __typename?: 'TransactionSearchConnection';
  edges: Array<TransactionSearchEdge>;
  pageInfo: PageInfo;
  /** The total number of matches, from Atlas Search's own count metadata. */
  totalCount: Scalars['Long']['output'];
};

export type TransactionSearchEdge = {
  __typename?: 'TransactionSearchEdge';
  cursor: Scalars['String']['output'];
  node: TransactionNode;
};

export enum TransactionSearchOrderField {
  /** Order by the transaction amount. */
  Amount = 'Amount',
  /** Order by the date the funds become available. */
  AvailableOn = 'AvailableOn',
  /** Order by when the transaction was created. */
  CreatedAt = 'CreatedAt',
  /** Order by relevance to the search terms. */
  Score = 'Score',
  /** Order by the status of the transaction. */
  Status = 'Status'
}

export type TransactionSearchOrderInput = {
  ascending: Scalars['Boolean']['input'];
  field: TransactionSearchOrderField;
};

export enum TransactionStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Disputed = 'Disputed',
  Failed = 'Failed',
  Incomplete = 'Incomplete',
  NotCaptured = 'NotCaptured',
  Paid = 'Paid',
  PartiallyRefunded = 'PartiallyRefunded',
  Pending = 'Pending',
  Refunded = 'Refunded'
}

export type TransactionTimeLineSubNode = {
  __typename?: 'TransactionTimeLineSubNode';
  /** The amount **in minor currency units** the event applied to, where the event has one. */
  amount?: Maybe<Scalars['Long']['output']>;
  eventTime: Scalars['Instant']['output'];
  eventType: TransactionEventType;
  identifier?: Maybe<Scalars['String']['output']>;
};

export type TransferEntrySubNode = {
  __typename?: 'TransferEntrySubNode';
  createdAt: Scalars['Instant']['output'];
  /** A unique key identifying the transfer request. */
  idempotencyKey: Scalars['String']['output'];
  /** The levy **in minor currency units** charged to the destination merchant. Negative for a reversed levy. */
  levy: Scalars['Long']['output'];
  /** The platform fees **in minor currency units** taken back from the transaction's merchant for this transfer. */
  surcharged: Scalars['Long']['output'];
  /** The amount transferred **in minor currency units**. Negative for a reversal. */
  transferred: Scalars['Long']['output'];
  /** The merchant funds were transferred to, or reversed from. */
  transferredToMerchantId: Scalars['String']['output'];
};

export type TransfersSubNode = {
  __typename?: 'TransfersSubNode';
  /** The immutable journal of transfers and reversals, oldest first. */
  entries: Array<TransferEntrySubNode>;
  /** The total levy **in minor currency units** charged to the destination merchants, net of any reversals. */
  totalLevied: Scalars['Long']['output'];
  /** The total platform fees **in minor currency units** taken back from the transaction's merchant. */
  totalSurcharged: Scalars['Long']['output'];
  /** The total **in minor currency units** transferred away from the transaction, net of any reversals. */
  totalTransferred: Scalars['Long']['output'];
  /** The amount of the transaction **in minor currency units** when the first transfer was made. */
  transactionAmount: Scalars['Long']['output'];
  transactionTransferId: Scalars['String']['output'];
};

export type TravelDetails = {
  __typename?: 'TravelDetails';
  airlineCode?: Maybe<Scalars['String']['output']>;
  bookingClass?: Maybe<Scalars['String']['output']>;
  confermaDeploymentId?: Maybe<Scalars['String']['output']>;
  dbiAe: DbiField;
  dbiAk: DbiField;
  dbiAu: DbiField;
  dbiBd: DbiField;
  dbiDs: DbiField;
  dbiIk: DbiField;
  dbiKs: DbiField;
  dbiPk: DbiField;
  dbiPr: DbiField;
  dbiRz: DbiField;
  flightTicketIndicator?: Maybe<Scalars['String']['output']>;
  routing?: Maybe<Scalars['String']['output']>;
  salesDate?: Maybe<Scalars['LocalDate']['output']>;
  serviceLine1?: Maybe<Scalars['String']['output']>;
  serviceLine2?: Maybe<Scalars['String']['output']>;
  serviceLine3?: Maybe<Scalars['String']['output']>;
  supplierIataNumber?: Maybe<Scalars['String']['output']>;
  supplierInvoiceNumber?: Maybe<Scalars['String']['output']>;
  supplierMerchantName?: Maybe<Scalars['String']['output']>;
  ticketNumber?: Maybe<Scalars['String']['output']>;
  travelAgencyInvoiceNumber?: Maybe<Scalars['String']['output']>;
  travelDate?: Maybe<Scalars['LocalDate']['output']>;
  travelType?: Maybe<TravelType>;
  travellerName?: Maybe<Scalars['String']['output']>;
};

export enum TravelType {
  Car = 'Car',
  Flight = 'Flight',
  Hotel = 'Hotel',
  Other = 'Other',
  Rail = 'Rail',
  Ship = 'Ship'
}

export type VerificationResult = {
  __typename?: 'VerificationResult';
  details: Array<Scalars['String']['output']>;
  errorCodes: Array<OnboardingErrorCode>;
  status: VerificationStatus;
};

export enum VerificationStatus {
  Pending = 'Pending',
  Verified = 'Verified'
}

/** Issued weekly on the given day of the week. */
export type Weekly = {
  __typename?: 'Weekly';
  issueDayOfWeek: DayOfWeek;
};

export type OrdersQueryQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  status?: InputMaybe<Array<OrderStatus> | OrderStatus>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderType?: InputMaybe<Array<OrderType> | OrderType>;
  createdAt?: InputMaybe<InstantFilterInput>;
}>;


export type OrdersQueryQuery = { __typename?: 'Queries', orders?: { __typename?: 'OrderSearchConnection', totalCount: number, edges: Array<{ __typename?: 'OrderSearchEdge', node: { __typename?: 'OrderNode', createdAt?: string | null, status: OrderStatus, description?: string | null, customerEmailAddress?: string | null, customerPhoneNumber?: string | null, customerName?: string | null, orderType: OrderType, referenceOrderId: string, orderId: string, amount: { __typename?: 'CurrencyAmount', minorCurrencyUnits: number, currency: Currency } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type TransactionsQueryQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  status?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  customerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  orderIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  payType?: InputMaybe<PayType>;
  createdAt?: InputMaybe<InstantFilterInput>;
  availableOn?: InputMaybe<LocalDateFilterInput>;
  orderBy?: InputMaybe<TransactionSearchOrderInput>;
}>;


export type TransactionsQueryQuery = { __typename?: 'Queries', transactions?: { __typename?: 'TransactionSearchConnection', totalCount: number, edges: Array<{ __typename?: 'TransactionSearchEdge', node: { __typename?: 'TransactionNode', transactionId: string, purchaseDetails: { __typename?: 'PurchaseDetailsSubNode', availableOn?: string | null, createdAt: string, status: TransactionStatus, payType: PayType, surchargeAmount: number, amount: { __typename?: 'CurrencyAmount', minorCurrencyUnits: number, currency: Currency } }, customer?: { __typename?: 'MerchantCustomerNode', customerId: string, customerName: string, customerEmailAddress: string, customerPhoneNumber?: string | null } | null, order: { __typename?: 'OrderNode', referenceOrderId: string, orderId: string, orderType: OrderType, description?: string | null }, refunds: Array<{ __typename?: 'RefundSubNode', refundId: string }>, merchant: { __typename?: 'MerchantNode', merchantId: string, businessProfile: { __typename?: 'BusinessProfile', businessName: string, brandName: string } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type PayoutsQueryQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  status?: InputMaybe<Array<PayoutStatus> | PayoutStatus>;
  payoutIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  createdAt?: InputMaybe<InstantFilterInput>;
  settlementDate?: InputMaybe<LocalDateFilterInput>;
  orderBy?: InputMaybe<PayoutSearchOrderInput>;
}>;


export type PayoutsQueryQuery = { __typename?: 'Queries', payouts?: { __typename?: 'PayoutSearchConnection', totalCount: number, edges: Array<{ __typename?: 'PayoutSearchEdge', node: { __typename?: 'PayoutNode', payoutId: string, status: PayoutStatus, createdAt?: string | null, settlementDate?: string | null, amount: { __typename?: 'CurrencyAmount', minorCurrencyUnits: number, currency: Currency } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type SettlementsQueryQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<AmountFilterInput>;
  payoutId?: InputMaybe<Scalars['String']['input']>;
  transactionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  entryTypes?: InputMaybe<Array<EntryType> | EntryType>;
  createdAt?: InputMaybe<InstantFilterInput>;
  settlementDate?: InputMaybe<LocalDateFilterInput>;
  orderBy?: InputMaybe<Array<SettlementEntryOrderInput> | SettlementEntryOrderInput>;
}>;


export type SettlementsQueryQuery = { __typename?: 'Queries', settlementEntries?: { __typename?: 'SettlementEntryConnection', totalCount: number, edges: Array<{ __typename?: 'SettlementEntryEdge', node: { __typename?: 'SettlementEntryNode', entryType: EntryType, createdAt?: string | null, settlementDate?: string | null, amount: { __typename?: 'CurrencyAmount', minorCurrencyUnits: number, currency: Currency }, payout?: { __typename?: 'PayoutNode', payoutId: string } | null, transaction?: { __typename?: 'TransactionNode', transactionId: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type SearchCustomersQueryQueryVariables = Exact<{
  merchantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCustomersQueryQuery = { __typename?: 'Queries', customers?: { __typename?: 'MerchantCustomerSearchConnection', edges: Array<{ __typename?: 'MerchantCustomerSearchEdge', node: { __typename?: 'MerchantCustomerNode', customerId: string, referenceCustomerId?: string | null, customerEmailAddress: string, customerName: string } }> } | null };

export type SearchOrdersQueryQueryVariables = Exact<{
  merchantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchOrdersQueryQuery = { __typename?: 'Queries', orders?: { __typename?: 'OrderSearchConnection', edges: Array<{ __typename?: 'OrderSearchEdge', node: { __typename?: 'OrderNode', orderId: string, referenceOrderId: string, description?: string | null } }> } | null };

export type SearchTransactionsQueryQueryVariables = Exact<{
  merchantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchTransactionsQueryQuery = { __typename?: 'Queries', transactions?: { __typename?: 'TransactionSearchConnection', edges: Array<{ __typename?: 'TransactionSearchEdge', node: { __typename?: 'TransactionNode', transactionId: string } }> } | null };

export type SearchPayoutsQueryQueryVariables = Exact<{
  merchantIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  query: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPayoutsQueryQuery = { __typename?: 'Queries', payouts?: { __typename?: 'PayoutSearchConnection', edges: Array<{ __typename?: 'PayoutSearchEdge', node: { __typename?: 'PayoutNode', payoutId: string } }> } | null };


export const OrdersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ordersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AmountFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderType"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InstantFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderType"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minorCurrencyUnits"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"referenceOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<OrdersQueryQuery, OrdersQueryQueryVariables>;
export const TransactionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"transactionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AmountFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PayType"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InstantFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"availableOn"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDateFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TransactionSearchOrderInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"transactionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"payType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payType"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"availableOn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"availableOn"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minorCurrencyUnits"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableOn"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"payType"}},{"kind":"Field","name":{"kind":"Name","value":"surchargeAmount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerPhoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refundId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"businessProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<TransactionsQueryQuery, TransactionsQueryQueryVariables>;
export const PayoutsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"payoutsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AmountFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payoutIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InstantFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settlementDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDateFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PayoutSearchOrderInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"payoutIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payoutIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"settlementDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settlementDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minorCurrencyUnits"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payoutId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"settlementDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<PayoutsQueryQuery, PayoutsQueryQueryVariables>;
export const SettlementsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"settlementsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AmountFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payoutId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entryTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EntryType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InstantFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settlementDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocalDateFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettlementEntryOrderInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settlementEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"payoutId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payoutId"}}},{"kind":"Argument","name":{"kind":"Name","value":"transactionIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"entryTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entryTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"createdAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"settlementDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settlementDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minorCurrencyUnits"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payoutId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"settlementDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SettlementsQueryQuery, SettlementsQueryQueryVariables>;
export const SearchCustomersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchCustomersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchantIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchCustomersQueryQuery, SearchCustomersQueryQueryVariables>;
export const SearchOrdersQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchOrdersQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchantIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"referenceOrderId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchOrdersQueryQuery, SearchOrdersQueryQueryVariables>;
export const SearchTransactionsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchTransactionsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchantIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchTransactionsQueryQuery, SearchTransactionsQueryQueryVariables>;
export const SearchPayoutsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchPayoutsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payouts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchantIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payoutId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchPayoutsQueryQuery, SearchPayoutsQueryQueryVariables>;